// Kabin Memurluğu Eğitimi - İçerikler
import { interviewContents } from "./interviewContents";
// Senaryo tabanlı quiz'ler, oyunlar ve ders içerikleri

// Eski modül içerikleri
import cabinCrewContentsM11 from './cabinCrewContentsM11';
import cabinCrewContentsM12 from './cabinCrewContentsM12';
import cabinCrewContentsM13 from './cabinCrewContentsM13';
import cabinCrewContentsM14 from './cabinCrewContentsM14';
import cabinCrewContentsM15 from './cabinCrewContentsM15';
import cabinCrewContentsM16 from './cabinCrewContentsM16';
import cabinCrewContentsM1Extra from './cabinCrewContentsM1Extra';
import cabinCrewContentsM2Extra from './cabinCrewContentsM2Extra';
import cabinCrewContentsM3Extra from './cabinCrewContentsM3Extra';
import cabinCrewContentsM4Extra from './cabinCrewContentsM4Extra';
import cabinCrewContentsM5Extra from './cabinCrewContentsM5Extra';
import cabinCrewContentsM6Extra from './cabinCrewContentsM6Extra';
import cabinCrewContentsM8Extra from './cabinCrewContentsM8Extra';
import cabinCrewContentsM9Extra from './cabinCrewContentsM9Extra';
import cabinCrewContentsM1U3to6 from './cabinCrewContentsM1U3to6';
import cabinCrewContentsM2U3to6 from './cabinCrewContentsM2U3to6';
import cabinCrewContentsM3U3to6 from './cabinCrewContentsM3U3to6';
import cabinCrewContentsM4U3to6 from './cabinCrewContentsM4U3to6';
import cabinCrewContentsM5U3to7 from './cabinCrewContentsM5U3to7';

// YENİ İNTERAKTİF İÇERİKLER - Modül 2-16
import cabinCrewContentsM2Interactive from './cabinCrewContentsM2Interactive';
import cabinCrewContentsM3Interactive from './cabinCrewContentsM3Interactive';
import cabinCrewContentsM4Interactive from './cabinCrewContentsM4Interactive';
import cabinCrewContentsM5Interactive from './cabinCrewContentsM5Interactive';
import cabinCrewContentsM6Interactive from './cabinCrewContentsM6Interactive';
import cabinCrewContentsM7Interactive from './cabinCrewContentsM7Interactive';
import cabinCrewContentsM8Interactive from './cabinCrewContentsM8Interactive';
import cabinCrewContentsM9Interactive from './cabinCrewContentsM9Interactive';
import cabinCrewContentsM10Interactive from './cabinCrewContentsM10Interactive';
import cabinCrewContentsM11M12Interactive from './cabinCrewContentsM11M12Interactive';
import cabinCrewContentsM13M14Interactive from './cabinCrewContentsM13M14Interactive';
import cabinCrewContentsM15M16Interactive from './cabinCrewContentsM15M16Interactive';

export const cabinCrewContentsBase = {
  // ==================== MODÜL 1: KABİN MEMURLUĞU GERÇEĞİ ====================
  // Ünite 1: Mesleğin Gerçek Tanımı - TAMAMEN İNTERAKTİF
  
  'CM-M1-U1-L1': {
    lesson_id: 'CM-M1-U1-L1',
    title: 'Kabin Memurluğu Nedir?',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '✈️ Kabin Memurluğu: Gerçek Tanım',
      intro: 'Kabin memurluğu hakkında 4 iddia var. Hangisi DOĞRU?',
      challenge: {
        type: 'multipleChoice',
        question: 'Kabin memurlarının BİRİNCİL görevi nedir?',
        options: [
          { text: '🍽️ Yemek ve içecek servisi yapmak', isCorrect: false, feedback: '❌ Hayır! Servis İKİNCİL görevdir.' },
          { text: '🛡️ Yolcu güvenliğini sağlamak', isCorrect: true, feedback: '✅ DOĞRU! Kabin memuru önce GÜVENLİK personelidir!' },
          { text: '🛒 Duty free satışı yapmak', isCorrect: false, feedback: '❌ Hayır! Satış ek görevdir.' },
          { text: '😊 Yolcuları eğlendirmek', isCorrect: false, feedback: '❌ Hayır! Bu görev değil.' }
        ]
      },
      facts: [
        { icon: '🛡️', title: 'Gerçek #1', text: 'Kabin memuru = GÜVENLİK PERSONELİ' },
        { icon: '🚨', title: 'Gerçek #2', text: 'Acil durumda HAYAT kurtarırsınız' },
        { icon: '📚', title: 'Gerçek #3', text: 'Önce güvenlik eğitimi, sonra servis' },
        { icon: '💪', title: 'Gerçek #4', text: 'Sorumluluk ve disiplin ŞART' }
      ]
    }
  },
  
  'CM-M1-U1-L1B': {
    lesson_id: 'CM-M1-U1-L1B',
    title: '🎮 Hızlı Test: Meslek Algısı',
    type: 'truefalse',
    duration: 2,
    xp: 30,
    truefalse: {
      statements: [
        { statement: 'Kabin memurları öncelikle servis personelidir.', isTrue: false, explanation: '❌ Hayır! Öncelikle GÜVENLİK personelidir.' },
        { statement: 'Mülakatta "gezmek istiyorum" demek iyi puan alır.', isTrue: false, explanation: '❌ Bu cevap SİZİ ELER!' },
        { statement: 'Havayolları önce güvenlik eğitimi verir.', isTrue: true, explanation: '✅ Doğru! Güvenlik her zaman önce.' },
        { statement: 'Acil durumda tahliyeyi kabin ekibi yönetir.', isTrue: true, explanation: '✅ Doğru! Bu temel görevlerden.' },
        { statement: 'Duty free satışı birincil görevdir.', isTrue: false, explanation: '❌ Hayır! Satış ek görevdir.' },
      ]
    }
  },
  
  'CM-M1-U1-L2': {
    lesson_id: 'CM-M1-U1-L2',
    title: 'Güvenlik Sorumluluğu',
    type: 'scenario',
    duration: 3,
    xp: 35,
    scenario: {
      question: '🛫 SENARYO: Uçuş öncesi brifing',
      context: 'Kaptan uçuşta şiddetli türbülans beklendiğini söylüyor. Kabin ekibi ne yapmalı?',
      options: [
        { id: 'A', text: 'Servis hazırlığına devam et, sorun yok', isCorrect: false },
        { id: 'B', text: 'Güvenlik önlemlerini artır, servis planını uyarla', isCorrect: true },
        { id: 'C', text: 'Yolculara türbülans olacağını söyleme', isCorrect: false },
        { id: 'D', text: 'Kaptan abartıyor, normal devam et', isCorrect: false }
      ],
      feedback: {
        correct: '✅ DOĞRU! Güvenlik HER ZAMAN önce gelir. Türbülans bekleniyorsa servis planı değişir!',
        wrong: '❌ Güvenlik ihmali! Kabin ekibi güvenlik uyarılarını ciddiye almalı.'
      },
      explanation: 'Kabin memurunun birinci görevi GÜVENLİKtir. Türbülans varsa sıcak içecek servisi tehlikelidir!'
    }
  },
  
  'CM-M1-U1-L2B': {
    lesson_id: 'CM-M1-U1-L2B',
    title: '🎮 Sırala: Görev Öncelikleri',
    type: 'dragdrop',
    duration: 2,
    xp: 35,
    dragdrop: {
      instruction: '📋 Kabin memurunun görevlerini ÖNEMLİ\'den DAHA AZ ÖNEMLİ\'ye sırala',
      items: [
        { text: '🛡️ Yolcu güvenliğini sağlamak', order: 1 },
        { text: '🚨 Acil durum prosedürlerini uygulamak', order: 2 },
        { text: '🏥 İlk yardım müdahalesi yapmak', order: 3 },
        { text: '🍽️ Yemek servisi yapmak', order: 4 },
        { text: '🛒 Duty free satışı yapmak', order: 5 },
      ]
    }
  },
  
  'CM-M1-U1-L3': {
    lesson_id: 'CM-M1-U1-L3',
    title: '⚡ Zaman Yarışı: Meslek Bilgisi',
    type: 'timerace',
    duration: 3,
    xp: 50,
    timerace: {
      timePerQuestion: 6,
      questions: [
        { q: 'Kabin memurunun #1 görevi?', options: ['Servis', 'Güvenlik', 'Satış', 'Temizlik'], correct: 1 },
        { q: 'Mülakatta ne DEMEMELİ?', options: ['Güvenlik', 'Gezmek istiyorum', 'Sorumluluk', 'Takım'], correct: 1 },
        { q: 'Türbülans varsa ne yapılır?', options: ['Servis devam', 'Güvenlik önlemi', 'Hiçbir şey', 'Panik'], correct: 1 },
        { q: 'Acil durumda kim yönetir?', options: ['Yolcu', 'Kabin ekibi', 'Polis', 'Güvenlik'], correct: 1 },
        { q: 'İlk eğitim nedir?', options: ['Servis', 'Satış', 'Güvenlik', 'Dil'], correct: 2 },
        { q: 'Tahliyeyi kim yapar?', options: ['Pilot', 'Kabin ekibi', 'Yer ekibi', 'Yolcu'], correct: 1 },
      ]
    }
  },
  
  'CM-M1-U1-L3B': {
    lesson_id: 'CM-M1-U1-L3B',
    title: 'Senaryo: Mülakat Sorusu',
    type: 'scenario',
    duration: 3,
    xp: 40,
    scenario: {
      question: '💼 MÜLAKAT: "Kabin memurluğu sizin için ne ifade ediyor?"',
      context: 'Bu soru HER mülakatta sorulur. Cevabınız mesleği nasıl algıladığınızı gösterir.',
      options: [
        { id: 'A', text: '"Dünyayı gezmek ve iyi maaş almak"', isCorrect: false },
        { id: 'B', text: '"Üniforma giymek, prestijli bir iş"', isCorrect: false },
        { id: 'C', text: '"Yolcu güvenliği ve takım sorumluluğu"', isCorrect: true },
        { id: 'D', text: '"Esnek çalışma ve tatil fırsatları"', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 MÜKEMMEL! Bu cevap mesleğin özünü anladığınızı gösterir!',
        wrong: '⚠️ DİKKAT! Bu tarz cevaplar sizi ELER. Güvenlik ve sorumluluk vurgusu yapın!'
      },
      explanation: 'Havayolları "gezmek isteyen" değil, "sorumluluk alabilen" adayları arar!'
    }
  },

  // Ünite 2: Havacılık Sektörü
  'CM-M1-U2-L1': {
    lesson_id: 'CM-M1-U2-L1',
    title: 'Havayolu Şirketleri',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🌍 Havayolu Türleri',
      intro: 'Dünyada binlerce havayolu var. 3 ana kategoriye ayrılır:',
      categories: [
        { icon: '⭐', title: 'Full-Service', examples: 'THY, Emirates, Lufthansa', desc: 'Lüks servis, yemek dahil' },
        { icon: '💰', title: 'Low-Cost', examples: 'Pegasus, Ryanair, EasyJet', desc: 'Düşük fiyat, ekstra ücret' },
        { icon: '🏖️', title: 'Charter', examples: 'SunExpress, Corendon', desc: 'Tatil paketleri' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Pegasus hangi kategoride?',
        options: [
          { text: 'Full-Service', isCorrect: false, feedback: '❌ Pegasus düşük maliyetli model kullanır' },
          { text: 'Low-Cost', isCorrect: true, feedback: '✅ Doğru! Pegasus bir low-cost havayoludur' },
          { text: 'Charter', isCorrect: false, feedback: '❌ Charter tatil paketleri için' }
        ]
      }
    }
  },
  
  'CM-M1-U2-L1B': {
    lesson_id: 'CM-M1-U2-L1B',
    title: '🎮 Eşleştir: Havayolları',
    type: 'matching',
    duration: 3,
    xp: 35,
    matching: {
      instruction: 'Havayollarını doğru kategorileriyle eşleştir',
      pairs: [
        { id: 1, left: 'Turkish Airlines', right: 'Star Alliance' },
        { id: 2, left: 'Emirates', right: 'Dubai merkezli' },
        { id: 3, left: 'Pegasus', right: 'Low-cost' },
        { id: 4, left: 'Qatar Airways', right: 'OneWorld' },
        { id: 5, left: 'Lufthansa', right: 'Alman bayrak taşıyıcı' },
        { id: 6, left: 'Ryanair', right: 'Avrupa low-cost' },
      ]
    }
  },
  
  'CM-M1-U2-L2': {
    lesson_id: 'CM-M1-U2-L2',
    title: 'Kariyer Yolları',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '📈 Kariyer Basamakları',
      intro: 'Kabin ekibinde kariyer yolculuğu:',
      steps: [
        { level: 1, title: '👶 Junior Cabin Crew', desc: 'Başlangıç - 0-2 yıl', color: 'blue' },
        { level: 2, title: '👨‍✈️ Senior Cabin Crew', desc: 'Deneyimli - 2-5 yıl', color: 'green' },
        { level: 3, title: '🎖️ Purser / Cabin Chief', desc: 'Ekip lideri - 5+ yıl', color: 'purple' },
        { level: 4, title: '👑 Cabin Manager', desc: 'Yönetici - 10+ yıl', color: 'gold' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Senior\'dan sonraki basamak?',
        options: [
          { text: 'Junior', isCorrect: false, feedback: '❌ Junior başlangıç pozisyonu' },
          { text: 'Purser', isCorrect: true, feedback: '✅ Doğru! Purser ekip lideridir' },
          { text: 'Manager', isCorrect: false, feedback: '❌ Manager en üst pozisyon' }
        ]
      }
    }
  },
  
  'CM-M1-U2-L2B': {
    lesson_id: 'CM-M1-U2-L2B',
    title: '🎮 Sırala: Kariyer Basamakları',
    type: 'dragdrop',
    duration: 2,
    xp: 30,
    dragdrop: {
      instruction: 'Kariyer basamaklarını ALTTAN ÜSTE sırala',
      items: [
        { text: '👶 Junior Cabin Crew', order: 1 },
        { text: '👨‍✈️ Senior Cabin Crew', order: 2 },
        { text: '🎖️ Purser / Cabin Chief', order: 3 },
        { text: '👑 Cabin Manager', order: 4 },
      ]
    }
  },
  
  'CM-M1-U2-L3': {
    lesson_id: 'CM-M1-U2-L3',
    title: '⚡ Zaman Yarışı: Sektör',
    type: 'timerace',
    duration: 3,
    xp: 55,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'THY hangi ittifakta?', options: ['OneWorld', 'Star Alliance', 'SkyTeam', 'Yok'], correct: 1 },
        { q: 'Low-cost havayolu?', options: ['Emirates', 'Pegasus', 'THY', 'Qatar'], correct: 1 },
        { q: 'Başlangıç pozisyonu?', options: ['Purser', 'Senior', 'Junior', 'Manager'], correct: 2 },
        { q: 'Senior sonrası?', options: ['Junior', 'Purser', 'Manager', 'Eğitmen'], correct: 1 },
        { q: 'Dubai merkezli?', options: ['THY', 'Emirates', 'Pegasus', 'Lufthansa'], correct: 1 },
        { q: 'OneWorld üyesi?', options: ['THY', 'Emirates', 'Qatar', 'Pegasus'], correct: 2 },
        { q: 'Kaç yıl Senior için?', options: ['0-1', '2-5', '10+', '15+'], correct: 1 },
      ]
    }
  },
  
  'CM-M1-U2-L4': {
    lesson_id: 'CM-M1-U2-L4',
    title: '📝 Ünite 2 Sınavı',
    type: 'quiz',
    duration: 4,
    xp: 50,
    quiz: {
      questions: [
        { q: 'Kabin memurunun birincil görevi?', options: ['Yemek servisi', 'Yolcu güvenliği', 'Duty free', 'Eğlence'], correct: 1 },
        { q: 'THY hangi ittifakta?', options: ['OneWorld', 'SkyTeam', 'Star Alliance', 'Hiçbiri'], correct: 2 },
        { q: 'Başlangıç pozisyonu?', options: ['Purser', 'Senior', 'Junior', 'Manager'], correct: 2 },
        { q: 'Low-cost havayolu örneği?', options: ['Emirates', 'Pegasus', 'Qatar', 'Singapore'], correct: 1 },
        { q: 'Purser ne demek?', options: ['Yeni başlayan', 'Ekip lideri', 'Pilot', 'Yönetici'], correct: 1 },
      ]
    }
  },

  // Ünite 3: Günlük Hayat
  'CM-M1-U3-L1': {
    lesson_id: 'CM-M1-U3-L1',
    title: 'Bir Günün Anatomisi',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '⏰ Kabin Memurunun Bir Günü',
      intro: 'Tipik bir uçuş günü nasıl geçer?',
      timeline: [
        { time: '04:00', icon: '⏰', activity: 'Uyanış', desc: 'Sabah 6 uçuşu için erken kalkmak' },
        { time: '05:00', icon: '🏨', activity: 'Hazırlık', desc: 'Üniforma, makyaj, evrak kontrolü' },
        { time: '05:30', icon: '🚐', activity: 'Havalimanı', desc: 'Ekip servisi veya kendi ulaşım' },
        { time: '06:00', icon: '📋', activity: 'Brifing', desc: 'Ekiple buluşma, görev dağılımı' },
        { time: '06:30', icon: '✈️', activity: 'Uçuş hazırlık', desc: 'Kabin kontrolü, yolcu karşılama' },
        { time: '07:00', icon: '🛫', activity: 'Kalkış', desc: 'Güvenlik gösterimi, servis' },
        { time: '10:00', icon: '🛬', activity: 'Varış', desc: 'İniş, yolcu uğurlama' },
        { time: '11:00', icon: '🔄', activity: 'Dönüş uçuşu', desc: 'Yeni yolcular, yeni servis' },
        { time: '15:00', icon: '🏠', activity: 'Eve dönüş', desc: 'Günlük raporlar, dinlenme' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Uçuştan kaç saat önce havalimanında olunmalı?',
        options: [
          { text: '30 dakika', isCorrect: false, feedback: '❌ Bu çok kısa!' },
          { text: '1-1.5 saat', isCorrect: true, feedback: '✅ Brifing ve hazırlık için yeterli' },
          { text: '3 saat', isCorrect: false, feedback: '❌ Bu kadar erken gerekmez' }
        ]
      }
    }
  },
  
  'CM-M1-U3-L2': {
    lesson_id: 'CM-M1-U3-L2',
    title: 'Çalışma Saatleri',
    type: 'scenario',
    duration: 3,
    xp: 35,
    scenario: {
      question: '📅 SENARYO: Haftalık program',
      context: 'Kabin memuru olarak ayda ortalama kaç uçuş yaparsınız?',
      options: [
        { id: 'A', text: '5-10 uçuş (haftada 1-2)', isCorrect: false },
        { id: 'B', text: '15-20 uçuş (haftada 4-5)', isCorrect: true },
        { id: 'C', text: '30+ uçuş (günde 2)', isCorrect: false },
        { id: 'D', text: 'Sabit, her gün aynı', isCorrect: false }
      ],
      feedback: {
        correct: '✅ Doğru! Haftada ortalama 4-5 uçuş, aylık 15-20 uçuş normal.',
        wrong: '❌ Kabin memurları rotasyonlu çalışır, her hafta program değişir.'
      },
      explanation: 'Uçuş programları rotasyona göre belirlenir. Bazı haftalar yoğun, bazı haftalar hafif olabilir.'
    }
  },
  
  'CM-M1-U3-L3': {
    lesson_id: 'CM-M1-U3-L3',
    title: 'Layover Hayatı',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🏨 Layover: Yurtdışı Konaklaması',
      intro: 'Uzun mesafe uçuşlarında "layover" yapılır',
      facts: [
        { icon: '🛏️', title: 'Otel', text: 'Havayolu 4-5 yıldızlı otel sağlar' },
        { icon: '🍽️', title: 'Yemek', text: 'Günlük yemek harcırahı verilir' },
        { icon: '🚐', title: 'Ulaşım', text: 'Havalimanı-otel transferi havayolundan' },
        { icon: '⏰', title: 'Süre', text: '24-72 saat arası dinlenme' },
        { icon: '🌍', title: 'Şehir', text: 'Serbest zamanı şehri keşfetmek için kullanabilirsiniz' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Layover masraflarını kim karşılar?',
        options: [
          { text: 'Kabin memuru kendi cebinden', isCorrect: false, feedback: '❌ Hayır!' },
          { text: 'Havayolu şirketi', isCorrect: true, feedback: '✅ Otel, yemek, transfer havayolundan' },
          { text: 'Yarı yarıya paylaşım', isCorrect: false, feedback: '❌ Hayır!' }
        ]
      }
    }
  },
  
  'CM-M1-U3-L4': {
    lesson_id: 'CM-M1-U3-L4',
    title: '🎮 Günlük Rutin Eşleştir',
    type: 'matching',
    duration: 3,
    xp: 40,
    matching: {
      instruction: 'Zamanları aktivitelerle eşleştir',
      pairs: [
        { id: 1, left: '05:00', right: 'Hazırlık & Üniforma' },
        { id: 2, left: '06:00', right: 'Ekip Brifingi' },
        { id: 3, left: '06:30', right: 'Kabin Kontrolü' },
        { id: 4, left: '07:00', right: 'Güvenlik Gösterimi' },
        { id: 5, left: '10:00', right: 'Varış & Yolcu Uğurlama' },
        { id: 6, left: '15:00', right: 'Eve Dönüş & Dinlenme' },
      ]
    }
  },
  
  'CM-M1-U3-L5': {
    lesson_id: 'CM-M1-U3-L5',
    title: '⚡ Zaman Yarışı: Günlük Hayat',
    type: 'timerace',
    duration: 3,
    xp: 55,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'Uçuştan kaç saat önce havalimanı?', options: ['30dk', '1-1.5 saat', '3 saat', '5 saat'], correct: 1 },
        { q: 'Layover masrafı kim öder?', options: ['Ekip', 'Havayolu', 'Yolcu', 'Paylaşım'], correct: 1 },
        { q: 'Brifing nerede yapılır?', options: ['Uçakta', 'Havalimanı', 'Otelde', 'Online'], correct: 1 },
        { q: 'Ortalama aylık uçuş?', options: ['5', '15-20', '30', '50'], correct: 1 },
        { q: 'Layover süresi?', options: ['2 saat', '24-72 saat', '1 hafta', '1 ay'], correct: 1 },
        { q: 'İlk iş sabah ne?', options: ['Uçuş', 'Brifing', 'Hazırlık', 'Servis'], correct: 2 },
      ]
    }
  },

  // Ünite 4: Kariyer Yolculuğu  
  'CM-M1-U4-L1': {
    lesson_id: 'CM-M1-U4-L1',
    title: 'Kariyer Basamakları',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🎯 Yükselme Yolları',
      intro: 'Kabin ekibinde nasıl yükselirsiniz?',
      paths: [
        { icon: '📈', title: 'Klasik Yol', steps: ['Junior → Senior → Purser → Manager'] },
        { icon: '📚', title: 'Eğitmen Yolu', steps: ['Senior → Cabin Trainer → Training Manager'] },
        { icon: '🏢', title: 'Ofis Yolu', steps: ['Purser → Scheduling → Operations Manager'] },
        { icon: '🌍', title: 'VIP Yolu', steps: ['Senior → Business Class → First Class → Private Jet'] }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Cabin Trainer olmak için ne gerekir?',
        options: [
          { text: 'Junior olmak', isCorrect: false, feedback: '❌ Deneyim şart!' },
          { text: 'En az Senior + eğitim sertifikası', isCorrect: true, feedback: '✅ Doğru!' },
          { text: 'Pilot lisansı', isCorrect: false, feedback: '❌ Bu farklı bir kariyer' }
        ]
      }
    }
  },
  
  'CM-M1-U4-L2': {
    lesson_id: 'CM-M1-U4-L2',
    title: 'Farklı Havayolu Türleri',
    type: 'scenario',
    duration: 3,
    xp: 35,
    scenario: {
      question: '🤔 SENARYO: Hangisini tercih edersiniz?',
      context: 'THY (full-service) vs Pegasus (low-cost) - farklar neler?',
      options: [
        { id: 'A', text: 'THY: Daha uzun rotalar, daha fazla layover, prestij', isCorrect: true },
        { id: 'B', text: 'Pegasus: Daha az uçuş, daha çok maaş', isCorrect: false },
        { id: 'C', text: 'İkisi de aynı, fark yok', isCorrect: false },
        { id: 'D', text: 'Low-cost daha kolay, daha az sorumluluk', isCorrect: false }
      ],
      feedback: {
        correct: '✅ Doğru! THY uzun mesafe uçuşları ve layover fırsatları sunar.',
        wrong: '❌ Her havayolu tipinin avantaj/dezavantajları farklı!'
      },
      explanation: 'Full-service: Uzun rotalar, layover, servis yoğun. Low-cost: Kısa rotalar, turn-around, hızlı tempo.'
    }
  },
  
  'CM-M1-U4-L3': {
    lesson_id: 'CM-M1-U4-L3',
    title: 'Maaş ve Yan Haklar',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '💰 Kazanç ve Haklar',
      intro: 'Kabin memurları ne kazanır?',
      benefits: [
        { icon: '💵', title: 'Maaş', desc: 'Baz maaş + uçuş primi + layover harcırahı' },
        { icon: '✈️', title: 'Uçuş Hakkı', desc: 'Bedava/indirimli bilet (kendiniz + aile)' },
        { icon: '🏨', title: 'Layover', desc: '4-5 yıldız otel + yemek' },
        { icon: '🏥', title: 'Sağlık', desc: 'Özel sağlık sigortası' },
        { icon: '🎓', title: 'Eğitim', desc: 'Sürekli eğitim ve sertifika' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Hangisi maaşa EK olarak gelir?',
        options: [
          { text: 'Sadece baz maaş', isCorrect: false, feedback: '❌ Ek ödemeler var!' },
          { text: 'Uçuş primi + layover harcırahı', isCorrect: true, feedback: '✅ Doğru! Uçtukça kazanç artar.' },
          { text: 'Tip parası', isCorrect: false, feedback: '❌ Kabin memurları tip almaz.' }
        ]
      }
    }
  },
  
  'CM-M1-U4-L4': {
    lesson_id: 'CM-M1-U4-L4',
    title: '⚡ Kariyer Yarışı',
    type: 'timerace',
    duration: 3,
    xp: 55,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'Purser olmak için kaç yıl?', options: ['1', '3', '5+', '10+'], correct: 2 },
        { q: 'Maaşa EK gelen?', options: ['Hiçbiri', 'Uçuş primi', 'Tip', 'İkramiye'], correct: 1 },
        { q: 'Bedava bilet kimlere?', options: ['Sadece size', 'Siz + aile', 'Herkese', 'Kimseye'], correct: 1 },
        { q: 'Layover oteli kaç yıldız?', options: ['2-3', '4-5', '1', 'Hostel'], correct: 1 },
        { q: 'Eğitmen olmak için?', options: ['Junior', 'Senior+', 'Pilot', 'Manager'], correct: 1 },
        { q: 'Full-service avantajı?', options: ['Kısa rot', 'Layover', 'Az uçuş', 'Düşük maaş'], correct: 1 },
      ]
    }
  },

  // Ünite 5: Mesleğin Zorlukları
  'CM-M1-U5-L1': {
    lesson_id: 'CM-M1-U5-L1',
    title: 'Fiziksel Zorluklar',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '💪 Fiziksel Gereksinimler',
      intro: 'Kabin memurluğu fiziksel olarak zorlu bir meslektir:',
      challenges: [
        { icon: '🦵', title: 'Ayakta Kalma', desc: '8-14 saat ayakta, dar alanda hareket' },
        { icon: '⏰', title: 'Düzensiz Uyku', desc: 'Gece uçuşları, jet lag, erken kalkış' },
        { icon: '🌡️', title: 'Kabin Ortamı', desc: 'Düşük nem, basınç değişimi, kuru hava' },
        { icon: '🏋️', title: 'Fiziksel Güç', desc: 'Ağır arabaları itmek, bagaj kaldırmak' },
        { icon: '🩺', title: 'Sağlık', desc: 'Düzenli sağlık kontrolleri zorunlu' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En büyük fiziksel zorluk?',
        options: [
          { text: 'Makyaj yapmak', isCorrect: false, feedback: '❌ Bu zorluk değil' },
          { text: 'Düzensiz uyku ve jet lag', isCorrect: true, feedback: '✅ Doğru! Vücut ritmi sürekli bozulur' },
          { text: 'Üniforma giymek', isCorrect: false, feedback: '❌ Bu zorluk değil' }
        ]
      }
    }
  },
  
  'CM-M1-U5-L2': {
    lesson_id: 'CM-M1-U5-L2',
    title: 'Duygusal Zorluklar',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '💭 Duygusal Yükler',
      intro: 'Mesleğin görünmeyen zorlukları:',
      challenges: [
        { icon: '👨‍👩‍👧', title: 'Aile Özlemi', desc: 'Özel günlerde, tatillerde çalışmak' },
        { icon: '😤', title: 'Zor Yolcular', desc: 'Kaba, sarhoş, agresif yolcularla başa çıkmak' },
        { icon: '🎭', title: 'Duygusal Emek', desc: 'Her zaman gülümsemek, profesyonel kalmak' },
        { icon: '🆘', title: 'Acil Durumlar', desc: 'Kriz anlarında soğukkanlılık' },
        { icon: '🔄', title: 'Belirsizlik', desc: 'Program değişiklikleri, iptal, rötar' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: '"Duygusal emek" ne demek?',
        options: [
          { text: 'Çok çalışmak', isCorrect: false, feedback: '❌ Fiziksel değil, duygusal' },
          { text: 'Ne hissedersen hisset, profesyonel davranmak', isCorrect: true, feedback: '✅ Doğru! Yorgun, üzgün olsan bile gülümsemek' },
          { text: 'Ağlamak', isCorrect: false, feedback: '❌ Bu iş yerinde yapılmaz' }
        ]
      }
    }
  },
  
  'CM-M1-U5-L3': {
    lesson_id: 'CM-M1-U5-L3',
    title: 'Senaryo: Zor Karar',
    type: 'scenario',
    duration: 4,
    xp: 45,
    scenario: {
      question: '😰 SENARYO: Aile vs İş',
      context: 'Annenizin doğum günü var ama o gün New York uçuşunuz çıktı. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Hasta raporu alıp uçuşu kaçırırım', isCorrect: false },
        { id: 'B', text: 'Uçuşa giderim, aileye video ile kutlarım', isCorrect: true },
        { id: 'C', text: 'İstifa ederim, aile daha önemli', isCorrect: false },
        { id: 'D', text: 'Şirkete yalan söyleyip mazeret bulurum', isCorrect: false }
      ],
      feedback: {
        correct: '✅ Profesyonel yaklaşım! Bu mesleği seçerken bu fedakarlıkları bilmelisiniz.',
        wrong: '❌ Bu yaklaşımlar profesyonel değil ve işinize mal olabilir.'
      },
      explanation: 'Kabin memurluğu fedakarlık gerektirir. Özel günlerde çalışmak mesleğin bir parçasıdır.'
    }
  },
  
  'CM-M1-U5-L4': {
    lesson_id: 'CM-M1-U5-L4',
    title: '🎮 Doğru mu Yanlış mı?',
    type: 'truefalse',
    duration: 3,
    xp: 40,
    truefalse: {
      statements: [
        { statement: 'Kabin memurları hep eğlenir, zorluk yok.', isTrue: false, explanation: '❌ Fiziksel ve duygusal zorluklar çok!' },
        { statement: 'Jet lag ciddi bir sağlık sorunudur.', isTrue: true, explanation: '✅ Vücut ritmi bozulur, kronikleşebilir.' },
        { statement: 'Zor yolcularla uğraşmak mesleğin parçası.', isTrue: true, explanation: '✅ Maalesef evet, profesyonel kalmalısınız.' },
        { statement: 'Tatillerde her zaman izinli olursunuz.', isTrue: false, explanation: '❌ Tatiller EN YOĞUN dönemlerdir!' },
        { statement: 'Aile özlemi sadece ilk yıllarda olur.', isTrue: false, explanation: '❌ Bu his hiç bitmez, sadece yönetirsiniz.' },
      ]
    }
  },

  // Ünite 6: Final
  'CM-M1-U6-L1': {
    lesson_id: 'CM-M1-U6-L1',
    title: 'Genel Tekrar',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '📚 Modül 1 Özeti',
      intro: 'Bu modülde öğrendikleriniz:',
      summary: [
        { icon: '🛡️', text: 'Kabin memuru = Güvenlik personeli' },
        { icon: '✈️', text: 'THY Star Alliance, 340+ destinasyon' },
        { icon: '📈', text: 'Kariyer: Junior → Senior → Purser → Manager' },
        { icon: '⏰', text: 'Günlük: Brifing → Uçuş → Layover' },
        { icon: '💪', text: 'Zorluklar: Fiziksel + Duygusal' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Bu modülün EN ÖNEMLİ mesajı?',
        options: [
          { text: 'Kabin memurluğu eğlenceli bir iş', isCorrect: false, feedback: '❌ Eğlenceli ama zorlukları var' },
          { text: 'Güvenlik birincil, sorumluluk büyük', isCorrect: true, feedback: '✅ MÜKEMMEL! Bu mesleğin özü!' },
          { text: 'Herkes kabin memuru olabilir', isCorrect: false, feedback: '❌ Kriterler ve fedakarlıklar var' }
        ]
      }
    }
  },
  
  'CM-M1-U6-L2': {
    lesson_id: 'CM-M1-U6-L2',
    title: '🎓 Modül 1 Final Sınavı',
    type: 'exam',
    duration: 8,
    xp: 100,
    quiz: {
      questions: [
        { q: 'Kabin memurunun BİRİNCİL görevi?', options: ['Servis', 'Satış', 'Güvenlik', 'Eğlence'], correct: 2 },
        { q: 'THY hangi ittifakta?', options: ['OneWorld', 'SkyTeam', 'Star Alliance', 'Yok'], correct: 2 },
        { q: 'Purser ne demek?', options: ['Yeni başlayan', 'Ekip lideri', 'Pilot', 'Hostess'], correct: 1 },
        { q: 'Layover masrafını kim öder?', options: ['Ekip', 'Havayolu', 'Yolcu', 'Devlet'], correct: 1 },
        { q: 'Mülakatta ne DEMEMELİ?', options: ['Güvenlik', 'Gezmek', 'Sorumluluk', 'Takım'], correct: 1 },
        { q: '"Duygusal emek" ne?', options: ['Ağlamak', 'Profesyonel kalmak', 'Çok çalışmak', 'Yorulmak'], correct: 1 },
        { q: 'Low-cost örneği?', options: ['THY', 'Emirates', 'Pegasus', 'Qatar'], correct: 2 },
        { q: 'Uçuştan kaç saat önce?', options: ['30dk', '1-1.5 saat', '3 saat', '5 saat'], correct: 1 },
        { q: 'Jet lag neden olur?', options: ['Yorgunluk', 'Saat dilimi', 'Yemek', 'Hava'], correct: 1 },
        { q: 'En önemli mülakat kriteri?', options: ['Güzellik', 'Boy', 'Takım uyumu', 'Dil'], correct: 2 },
      ]
    }
  },

  // ==================== MODÜL 2: HAVAYOLLARI ADAYDAN NE BEKLER? ====================
  'CM-M2-U1-L1': {
    lesson_id: 'CM-M2-U1-L1',
    title: 'Takım Uyumu',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Takım Uyumu: En Önemli Kriter',
      paragraphs: [
        'Grup mülakatlarında havayolları TEK BİR ŞEYİ arar: Ekip içinde uyumlu çalışabilir mi?',
        'Kabin ekibi her uçuşta farklı kişilerle çalışır. Uyum sağlayamayan, çatışma yaratan veya çok baskın olan adaylar elenir.',
        'Değerlendirilen davranışlar: Başkalarını dinleme, katkı sağlama, işbirliği yapma, çatışma çözmede yapıcı olma.',
        'DİKKAT: Çok sessiz kalmak da, çok baskın olmak da kötüdür. DENGE kurmak gerekir.'
      ],
      keyPoints: [
        'Takım uyumu #1 kriterdir',
        'Ne çok sessiz, ne çok baskın olun',
        'Başkalarını dinleyin ve dahil edin',
        'Yapıcı katkı sağlayın'
      ]
    }
  },
  'CM-M2-U1-L2': {
    lesson_id: 'CM-M2-U1-L2',
    title: 'İletişim Becerileri',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Etkili İletişim',
      paragraphs: [
        'Kabin memuru sürekli iletişim halindedir: Yolcular, ekip arkadaşları, kokpit, yer hizmetleri.',
        'İyi iletişim = Net, kibar, profesyonel. Karışık veya kaba iletişim kabul edilmez.',
        'Mülakatta değerlendirilen: Göz teması, beden dili, ses tonu, kelime seçimi, dinleme becerisi.',
        'İngilizce iletişim de önemlidir. Akıcı olmanız gerekmez ama temel iletişimi kurabilmelisiniz.'
      ],
      keyPoints: [
        'Net ve kibar konuşun',
        'Göz teması kurun',
        'Aktif dinleyin',
        'Beden dilinize dikkat edin'
      ]
    }
  },
  'CM-M2-U1-L3': {
    lesson_id: 'CM-M2-U1-L3',
    title: 'Senaryo: Kriter Testi',
    type: 'scenario',
    duration: 5,
    xp: 30,
    scenario: {
      question: 'Grup mülakatlarında en önemli değerlendirme kriteri hangisidir?',
      context: 'Havayolları grup aktivitelerinde sizin neyi değerlendiriyor?',
      options: [
        { id: 'A', text: 'Liderlik gösterme', isCorrect: false },
        { id: 'B', text: 'İletişim becerisi', isCorrect: false },
        { id: 'C', text: 'Takım uyumu', isCorrect: true },
        { id: 'D', text: 'İngilizce seviyesi', isCorrect: false }
      ],
      feedback: {
        correct: 'Doğru! Havayolları ekip içinde uyumlu çalışabilen adayları tercih eder. Liderlik ve iletişim de önemli, ama takım uyumu birincil kriterdir.',
        wrong: 'Bu kriterler önemli olsa da birincil değerlendirme unsuru değildir. Havayolları öncelikle "bu aday ekiple uyumlu çalışabilir mi?" sorusuna cevap arar.'
      },
      explanation: 'Kabin ekibi her uçuşta farklı kişilerle çalışır. Uyum sağlayamayan adaylar ne kadar yetenekli olursa olsun elenir.'
    }
  },
  'CM-M2-U2-L1': {
    lesson_id: 'CM-M2-U2-L1',
    title: 'Boy ve Erişim Mesafesi',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Fiziksel Gereklilikler: Boy',
      paragraphs: [
        'Havayollarının boy kriteri vardır. Bu estetik değil, GÜVENLİK gerekliliğidir.',
        'Neden boy önemli? Üst bagaj bölmelerine erişim, acil durum ekipmanlarına ulaşım, tahliye kapılarını açabilme.',
        'Genel kriter: 160-185 cm arası (havayoluna göre değişir). Bazı havayolları "arm reach" (kol erişimi) testi yapar.',
        'THY kriteri: Kadın min. 160 cm, erkek min. 168 cm. Emirates: Arm reach min. 212 cm (ayak parmak ucunda).'
      ],
      keyPoints: [
        'Boy kriteri güvenlik içindir',
        'Üst bölmelere erişim önemli',
        'Her havayolunun kriteri farklı',
        'Arm reach testi yapılabilir'
      ]
    }
  },
  'CM-M2-U2-L2': {
    lesson_id: 'CM-M2-U2-L2',
    title: 'Sağlık Gereksinimleri',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Sağlık Kriterleri',
      paragraphs: [
        'Kabin memuru olmak için sağlıklı olmanız gerekir. İşe alım sürecinde sağlık taraması yapılır.',
        'Temel kriterler: İyi görme (gözlük/lens olabilir), iyi işitme, kronik hastalık olmaması, bulaşıcı hastalık olmaması.',
        'Havacılık sağlık sertifikası (Class 2 Medical) alınır. Bu yıllık olarak yenilenir.',
        'Dövme politikası: Üniforma ile görünür dövme genellikle kabul edilmez. Havayoluna göre değişir.'
      ],
      keyPoints: [
        'Sağlık taraması zorunlu',
        'Görme/işitme iyi olmalı',
        'Görünür dövme çoğu yerde yasak',
        'Yıllık sağlık kontrolü var'
      ]
    }
  },
  'CM-M2-U2-L3': {
    lesson_id: 'CM-M2-U2-L3',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        {
          q: 'Grup mülakatında en önemli kriter nedir?',
          options: ['Liderlik', 'İngilizce', 'Takım uyumu', 'Deneyim'],
          correct: 2
        },
        {
          q: 'Boy kriteri neden var?',
          options: ['Estetik için', 'Güvenlik için', 'Prestij için', 'Gelenek'],
          correct: 1
        },
        {
          q: 'Arm reach testi ne ölçer?',
          options: ['Güç', 'Kol erişim mesafesi', 'Esneklik', 'Hız'],
          correct: 1
        },
        {
          q: 'Mülakatta ne kaçınılmalı?',
          options: ['Göz teması', 'Gülümseme', 'Çok baskın olmak', 'Dinleme'],
          correct: 2
        }
      ]
    }
  },

  // ==================== MODÜL 3: ADAY NASIL DAVRANMALI? ====================
  'CM-M3-U1-L1': {
    lesson_id: 'CM-M3-U1-L1',
    title: 'Aktif Dinleme',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Aktif Dinleme Becerisi',
      paragraphs: [
        'Grup mülakatında en önemli becerilerden biri AKTİF DİNLEMEdir. Çoğu aday konuşmaya odaklanır, dinlemeyi unutur.',
        'Aktif dinleme nasıl gösterilir? Konuşana bakma, baş sallama, not alma, söylenenlere referans verme.',
        'Değerlendirmeciler "Kim kimi dinliyor?" diye izler. Sadece kendi sözünü bekleyen adaylar negatif değerlendirilir.',
        'İpucu: Bir önceki konuşmacının söylediğine referans vererek başlayın. "Ali\'nin dediği gibi..." veya "Ayşe\'nin fikrine ek olarak..."'
      ],
      keyPoints: [
        'Konuşmaktan çok dinleyin',
        'Baş sallayarak ilgi gösterin',
        'Önceki konuşmacılara referans verin',
        'Not alın (izin veriliyorsa)'
      ]
    }
  },
  'CM-M3-U1-L2': {
    lesson_id: 'CM-M3-U1-L2',
    title: 'Katkı Sağlama',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Yapıcı Katkı',
      paragraphs: [
        'Grup çalışmasında sessiz kalmak kadar kötü bir şey yoktur. Ama her şeye atlayıp konuşmak da yanlıştır.',
        'Yapıcı katkı = Grubun ilerlemesine yardımcı olan, başkalarını dahil eden, çözüm odaklı fikirler.',
        'Yıkıcı katkı = Başkalarını eleştiren, çok uzun konuşan, sözü kesen, kendi fikrini dayatan.',
        'Altın kural: Konuştuğunuzda grup bundan faydalanmalı. "Ben konuşayım" değil "Gruba nasıl yardımcı olabilirim?" düşüncesi.'
      ],
      keyPoints: [
        'Sessiz kalmayın ama çok da konuşmayın',
        'Çözüm odaklı fikirler sunun',
        'Başkalarını dahil edin',
        'Eleştiri yerine öneri yapın'
      ]
    }
  },
  'CM-M3-U1-L3': {
    lesson_id: 'CM-M3-U1-L3',
    title: 'Senaryo: Sessiz Grup',
    type: 'scenario',
    duration: 5,
    xp: 30,
    scenario: {
      question: 'Grup çalışmasında kimse konuşmuyor. Ne yaparsınız?',
      context: 'Grup aktivitesi başladı ama herkes sessiz. Değerlendirmeciler izliyor.',
      options: [
        { id: 'A', text: 'Kontrolü alıp grubu yönetirim', isCorrect: false },
        { id: 'B', text: 'Sessiz kalırım, biri başlasın', isCorrect: false },
        { id: 'C', text: 'Diğer adayları nazikçe sürece dahil ederim', isCorrect: true },
        { id: 'D', text: 'Eğitmenin müdahale etmesini beklerim', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Kabin memuru ne baskın ne pasiftir, denge kurar. "Sizce nasıl başlayabiliriz?" gibi sorularla grubu harekete geçirmek idealdir.',
        wrong: 'Bu davranış grup uyumu açısından risklidir. Çok baskın olmak veya çok pasif kalmak değerlendirmecilerin gözünde negatif izlenim bırakır.'
      },
      explanation: 'Doğru yaklaşım: Nazikçe inisiyatif alın ama dayatmayın. "Belki herkes fikrini söyleyebilir?" gibi kapsayıcı bir başlangıç yapın.'
    }
  },
  'CM-M3-U2-L1': {
    lesson_id: 'CM-M3-U2-L1',
    title: 'Ne Baskın Ne Pasif',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Denge: Altın Kural',
      paragraphs: [
        'Havayolları iki tip adayı elemez: Çok baskın olanları ve çok pasif olanları.',
        'Çok baskın aday: Sürekli konuşur, sözü keser, fikrini dayatır, başkalarını dinlemez. Bu tip adaylar ekipte sorun yaratır.',
        'Çok pasif aday: Hiç konuşmaz, göz teması kurmaz, fikirsiz görünür. Bu tip adaylar acil durumda inisiyatif alamaz.',
        'İdeal aday: Uygun zamanda konuşur, başkalarını dinler, yapıcı katkı sağlar, gerektiğinde inisiyatif alır.'
      ],
      keyPoints: [
        'Çok baskın = Eleme',
        'Çok pasif = Eleme',
        'Denge = Başarı',
        'Uygun zamanda konuşun'
      ]
    }
  },
  'CM-M3-U2-L2': {
    lesson_id: 'CM-M3-U2-L2',
    title: 'Orta Yol Bulma',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Pratik İpuçları',
      paragraphs: [
        'Konuşma sırası: Hemen atlama, ama çok da bekleme. 2-3 kişi konuştuktan sonra katılın.',
        'Süre: Bir konuşmanız 30-60 saniye olsun. Uzun monologlardan kaçının.',
        'İçerik: Somut, çözüm odaklı fikirler. "Bence şöyle yapabiliriz..." formatı.',
        'Dahil etme: "Siz ne düşünüyorsunuz?" diye sessiz kalan birine soru yöneltin.'
      ],
      keyPoints: [
        '30-60 saniye konuşun',
        'Somut fikirler sunun',
        'Sessiz kalanları dahil edin',
        'Monologdan kaçının'
      ]
    }
  },
  'CM-M3-U2-L3': {
    lesson_id: 'CM-M3-U2-L3',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        {
          q: 'Aktif dinleme nasıl gösterilir?',
          options: ['Sessiz durma', 'Baş sallama ve referans verme', 'Not tutma', 'Soru sorma'],
          correct: 1
        },
        {
          q: 'Çok baskın aday ne yapar?',
          options: ['Dinler', 'Sözü keser', 'Sessiz kalır', 'Not alır'],
          correct: 1
        },
        {
          q: 'İdeal konuşma süresi ne kadar?',
          options: ['10 saniye', '30-60 saniye', '2 dakika', '5 dakika'],
          correct: 1
        },
        {
          q: 'Sessiz kalan adaya ne yapmalı?',
          options: ['Görmezden gel', 'Nazikçe dahil et', 'Eleştir', 'Şikayet et'],
          correct: 1
        }
      ]
    }
  },

  // ==================== MODÜL 4: KRİTİK HATALAR ====================
  'CM-M4-U1-L1': {
    lesson_id: 'CM-M4-U1-L1',
    title: 'Ezber vs Doğallık',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Ezber Cevapların Tehlikesi',
      paragraphs: [
        'İnternette "mülakat soruları ve cevapları" diye binlerce kaynak var. Adaylar bunları ezberliyor. BÜYÜK HATA!',
        'Değerlendirmeciler ezberi hemen anlar: Robotik ses tonu, göz teması kaybı, beklenmedik soruya yanıt verememe.',
        'Havayolları ezber cevap değil, GERÇEK REFLEKSİNİZİ ölçer. Acil durumda ezber işe yaramaz.',
        'Doğru yaklaşım: Konuları anlayın, kendi cümlelerinizle ifade edin, samimi olun.'
      ],
      keyPoints: [
        'Ezber = Eleme riski',
        'Değerlendirmeciler ezberi anlar',
        'Gerçek refleks ölçülür',
        'Samimi ve doğal olun'
      ]
    }
  },
  'CM-M4-U1-L2': {
    lesson_id: 'CM-M4-U1-L2',
    title: 'Gerçek Refleks',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Refleks Nedir?',
      paragraphs: [
        'Refleks = Beklenmedik durumda otomatik tepkiniz. Mülakatta asıl ölçülen budur.',
        'Örnek: "Yolcu size bağırdı, ne yaparsınız?" Ezberci: "Sakin kalırım, empati kurarım..." (robotik). Doğal: "Önce şaşırırım muhtemelen, ama sonra sakinleşip onu dinlemeye çalışırım" (gerçekçi).',
        'Değerlendirmeciler beklenmedik sorular sorar: "Ya yolcu Türkçe bilmiyorsa?", "Ya o sırada türbülans olursa?"',
        'Bu sorulara ezber cevap olmaz. Gerçek düşünce sürecinizi göstermeniz gerekir.'
      ],
      keyPoints: [
        'Refleks = Otomatik tepki',
        'Ezber yerine düşünün',
        'Gerçekçi cevaplar verin',
        'Takip sorularına hazır olun'
      ]
    }
  },
  'CM-M4-U1-L3': {
    lesson_id: 'CM-M4-U1-L3',
    title: 'Senaryo: Ezber Testi',
    type: 'scenario',
    duration: 5,
    xp: 30,
    scenario: {
      question: 'Ezber cevaplar neden risklidir?',
      context: 'Mülakat hazırlığında ezber yapmayı düşünüyorsunuz. Bu neden tehlikeli?',
      options: [
        { id: 'A', text: 'Zaman kaybettirir', isCorrect: false },
        { id: 'B', text: 'Samimiyetsiz görünür', isCorrect: false },
        { id: 'C', text: 'Gerçek refleksi göstermez', isCorrect: true },
        { id: 'D', text: 'İngilizceyi zayıf gösterir', isCorrect: false }
      ],
      feedback: {
        correct: 'Doğru! Havayolları ezberi değil gerçek refleksi ölçer. Acil durumda ezber cevaplar işe yaramaz, gerçek tepkiniz önemlidir.',
        wrong: 'Asıl risk, adayın gerçek davranışını gizlemesidir. Değerlendirmeciler sizin doğal tepkinizi görmek ister.'
      },
      explanation: 'Ezber yerine: Konuları anlayın, örnek senaryoları DÜŞÜNEREK pratik yapın, kendi kelimelerinizi kullanın.'
    }
  },
  'CM-M4-U2-L1': {
    lesson_id: 'CM-M4-U2-L1',
    title: 'Aşırı Konuşma',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Çok Konuşmak Hatası',
      paragraphs: [
        'Heyecan ve gerginlik adayları çok konuşturur. Bu BÜYÜK HATA!',
        'Çok konuşan aday: Başkalarına fırsat vermez, önemli noktaları kaçırır, dinlemediğini gösterir.',
        'Değerlendirmeciler düşüncesi: "Bu kişi uçakta yolcuyu dinler mi? Ekip arkadaşlarıyla uyumlu çalışır mı?"',
        'Kural: Az ve öz konuşun. Her cümleniz değer katmalı. Gereksiz detaylardan kaçının.'
      ],
      keyPoints: [
        'Az ve öz konuşun',
        'Başkalarına fırsat verin',
        'Gereksiz detay vermeyin',
        'Her cümle değer katmalı'
      ]
    }
  },
  'CM-M4-U2-L2': {
    lesson_id: 'CM-M4-U2-L2',
    title: 'Yetersiz Hazırlık',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Hazırlık Hataları',
      paragraphs: [
        'Bazı adaylar "Kendim olurum, hazırlık gereksiz" der. YANLIŞ! Hazırlık şart, ama DOĞRU hazırlık.',
        'Yanlış hazırlık: Cevap ezberlemek, tek soru üzerine yoğunlaşmak, şirket araştırması yapmamak.',
        'Doğru hazırlık: Şirketi araştırmak, mesleği anlamak, kendi güçlü/zayıf yönlerini bilmek, senaryo pratiği yapmak.',
        'En sık hata: "Neden bizim şirketimiz?" sorusuna hazırlıksız yakalanmak.'
      ],
      keyPoints: [
        'Hazırlık şart ama doğru hazırlık',
        'Şirketi araştırın',
        'Kendinizi tanıyın',
        'Senaryo pratiği yapın'
      ]
    }
  },
  'CM-M4-U2-L3': {
    lesson_id: 'CM-M4-U2-L3',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        {
          q: 'Ezber cevabın en büyük riski nedir?',
          options: ['Unutmak', 'Gerçek refleksi gizlemek', 'Uzun sürmek', 'Yanlış olmak'],
          correct: 1
        },
        {
          q: 'Çok konuşan aday ne mesajı verir?',
          options: ['Bilgili', 'Dinlemiyor', 'Özgüvenli', 'Hazırlıklı'],
          correct: 1
        },
        {
          q: 'Doğru hazırlık neyi içerir?',
          options: ['Cevap ezberlemek', 'Şirket araştırması', 'Tek soruya odaklanmak', 'Hiçbiri'],
          correct: 1
        },
        {
          q: 'Mülakatta ideal konuşma süresi?',
          options: ['5 saniye', '30-60 saniye', '3 dakika', 'Sınırsız'],
          correct: 1
        }
      ]
    }
  },

  // ==================== MODÜL 5: GERÇEK MÜLAKAT SORULARI ====================
  'CM-M5-U1-L1': {
    lesson_id: 'CM-M5-U1-L1',
    title: 'Empati Kurma',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Zor Yolcuya Empati',
      paragraphs: [
        'Zor yolcu senaryosu mülakatlarda EN SIK sorulan sorudur. Doğru yaklaşım: Empati + Prosedür.',
        'Empati = Yolcunun duygusunu anlamak ve kabul etmek. "Anlıyorum, bu durum sinir bozucu olmalı."',
        'DİKKAT: Sadece "sakin kalırım" demek yetmez. HOW? Nasıl sakin kalırsınız? Ne söylersiniz?',
        'Önemli: Empati göstermek = haklı vermek DEĞİL. Duyguyu kabul edersiniz ama kuralları uygularsınız.'
      ],
      keyPoints: [
        'Empati + Prosedür = Doğru cevap',
        'Duyguyu kabul edin',
        'Nasıl yapacağınızı açıklayın',
        'Empati ≠ Haklı vermek'
      ]
    }
  },
  'CM-M5-U1-L2': {
    lesson_id: 'CM-M5-U1-L2',
    title: 'Prosedür Takibi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Prosedür Odaklı Çözüm',
      paragraphs: [
        'Kabin memuru duygusal değil, PROSEDÜR odaklıdır. Her durumun bir prosedürü vardır.',
        'Zor yolcu prosedürü: 1) Sakin kal, 2) Dinle, 3) Empati göster, 4) Çözüm sun, 5) Gerekirse amire bildir.',
        'Mülakatta bu adımları sırayla söyleyin. "Önce sakin kalmaya çalışırım. Sonra yolcuyu dinlerim. Ardından..."',
        'ÖNEMLİ: "Amire bildiririm" deyip bırakmayın. Önce kendiniz çözmeye çalışın, amir son çare.'
      ],
      keyPoints: [
        'Her durumun prosedürü var',
        'Adımları sırayla söyleyin',
        'Önce kendiniz çözmeye çalışın',
        'Amir son çare'
      ]
    }
  },
  'CM-M5-U1-L3': {
    lesson_id: 'CM-M5-U1-L3',
    title: 'Senaryo: Zor Yolcu',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: 'Zor bir yolcu ile nasıl başa çıkarsınız?',
      context: 'Bir yolcu koltuk değişikliği istiyor ama uçak dolu. Size bağırmaya başlıyor.',
      options: [
        { id: 'A', text: 'Sakin olmaya çalışırım', isCorrect: false },
        { id: 'B', text: 'Yolcuyu uyarırım', isCorrect: false },
        { id: 'C', text: 'Empati kurar, prosedüre göre çözüm üretirim', isCorrect: true },
        { id: 'D', text: 'Hemen amire yönlendiririm', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Duygu değil süreç odaklı yaklaşım beklenir. "Anlıyorum bu sinir bozucu. Şu anda tüm koltuklar dolu ama iniş sonrası müşteri hizmetleri size yardımcı olabilir."',
        wrong: 'Bu cevaplar tek başına yeterli değildir. Havayolları hem empati hem prosedür beklenter. Sadece "sakin kalırım" veya "amire yönlendiririm" eksik cevaptır.'
      },
      explanation: 'İdeal cevap yapısı: 1) Duyguyu kabul et, 2) Durumu açıkla, 3) Alternatif sun, 4) Gerekirse escalate et.'
    }
  },
  'CM-M5-U2-L1': {
    lesson_id: 'CM-M5-U2-L1',
    title: 'Öncelik Belirleme',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Acil Durumda Öncelik',
      paragraphs: [
        'Acil durum soruları adayın öncelik belirleme yeteneğini ölçer.',
        'Havacılıkta öncelik sırası: 1) GÜVENLİK (yolcu ve ekip), 2) Uçağın bütünlüğü, 3) Zamanında hareket.',
        'Örnek soru: "Servis yapıyorsunuz, türbülans anons edildi, bir yolcu fenalaştı. Ne yaparsınız?"',
        'Cevap: Önce güvenlik (servisi bırak, pozisyon al), sonra yolcuyla ilgilen (türbülans geçtikten sonra).'
      ],
      keyPoints: [
        'Güvenlik her zaman #1',
        'Öncelik sırasını bilin',
        'Panik yapmayın',
        'Adım adım düşünün'
      ]
    }
  },
  'CM-M5-U2-L2': {
    lesson_id: 'CM-M5-U2-L2',
    title: 'Ekip Koordinasyonu',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Ekiple Çalışma',
      paragraphs: [
        'Acil durumda tek başınıza değilsiniz. EKİP olarak hareket edersiniz.',
        'Koordinasyon = Kimin ne yapacağını bilmek, iletişim kurmak, birbirine destek olmak.',
        'Mülakatta "biz" dili kullanın: "Ekip olarak hareket ederiz", "Purser\'a bilgi veririm".',
        '"Ben hallederim" yerine "Ekipçe çözeriz" demek daha iyi puan alır.'
      ],
      keyPoints: [
        'Ekip olarak hareket edin',
        '"Biz" dili kullanın',
        'İletişimi vurgulayın',
        'Tek başına kahraman olmayın'
      ]
    }
  },
  'CM-M5-U2-L3': {
    lesson_id: 'CM-M5-U2-L3',
    title: 'Senaryo: Acil Durum',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: 'Servis sırasında türbülans anons edildi ve bir yolcu fenalaştı. Ne yaparsınız?',
      context: 'İki olay aynı anda yaşanıyor. Öncelik belirlemeniz gerekiyor.',
      options: [
        { id: 'A', text: 'Önce yolcuyla ilgilenirim', isCorrect: false },
        { id: 'B', text: 'Servise devam ederim', isCorrect: false },
        { id: 'C', text: 'Servisi bırakır, pozisyon alır, sonra yolcuya bakarım', isCorrect: true },
        { id: 'D', text: 'Kokpite haber veririm', isCorrect: false }
      ],
      feedback: {
        correct: 'Doğru! Güvenlik öncelikli. Türbülansta önce servis arabasını kilitle ve jump seat\'e otur. Türbülans geçince yolcuyla ilgilen. Bu düşünce sürecini mülakatta gösterin.',
        wrong: 'Güvenlik her zaman birinci önceliktir. Türbülansta pozisyon almak hem sizin hem yolcuların güvenliği için zorunludur.'
      },
      explanation: 'Öncelik: 1) Güvenlik pozisyonu al, 2) Türbülans geçsin, 3) Yolcuya müdahale et, 4) Gerekirse tıbbi yardım iste.'
    }
  },

  // ==================== MODÜL 6: MÜLAKAT PSİKOLOJİSİ ====================
  'CM-M6-U1-L1': {
    lesson_id: 'CM-M6-U1-L1',
    title: 'Savunmacı Olmamak',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Eleştiriye Açık Olmak',
      paragraphs: [
        'Mülakatta değerlendirmeci sizi test etmek için eleştirebilir. "Bu cevap yeterli değil" diyebilir.',
        'YANLIŞ tepki: Savunmaya geçmek, özür dilemek, paniğe kapılmak.',
        'DOĞRU tepki: Sakin kalmak, geri bildirim istemek, toparlamak.',
        'Bu TEST\'tir. Gerçek bir eleştiri olmayabilir. Tepkinizi ölçüyorlar.'
      ],
      keyPoints: [
        'Eleştiri bir TEST olabilir',
        'Savunmaya geçmeyin',
        'Geri bildirim isteyin',
        'Sakin kalın ve toplayın'
      ]
    }
  },
  'CM-M6-U1-L2': {
    lesson_id: 'CM-M6-U1-L2',
    title: 'Gelişim Odaklılık',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Gelişime Açıklık',
      paragraphs: [
        'Havayolları "gelişime açık" adayları ister. Mükemmel olmak zorunda değilsiniz.',
        'Zayıf yönünüzü sorduklarında: "Yok" demeyin. Gerçekçi bir zayıflık söyleyin ve nasıl geliştirdiğinizi ekleyin.',
        'Örnek: "Bazen detaylara çok takılabiliyorum. Bunu fark ettim ve şimdi öncelik belirlemeye çalışıyorum."',
        'Bu yaklaşım özeleştiri + gelişim gösterir. İkisi de pozitif.'
      ],
      keyPoints: [
        '"Zayıflığım yok" demeyin',
        'Gerçekçi zayıflık söyleyin',
        'Nasıl geliştirdiğinizi ekleyin',
        'Özeleştiri + Gelişim = Pozitif'
      ]
    }
  },
  'CM-M6-U1-L3': {
    lesson_id: 'CM-M6-U1-L3',
    title: 'Senaryo: Eleştiri',
    type: 'scenario',
    duration: 5,
    xp: 30,
    scenario: {
      question: 'Değerlendirmeci cevabınızı yetersiz bulduğunu söylüyor. Ne yaparsınız?',
      context: 'Bir soruyu cevapladınız. Değerlendirmeci "Bu cevap yeterli değil" dedi.',
      options: [
        { id: 'A', text: 'Savunmaya geçerim', isCorrect: false },
        { id: 'B', text: 'Susarım', isCorrect: false },
        { id: 'C', text: 'Geri bildirim isteyip toparlarım', isCorrect: true }
      ],
      feedback: {
        correct: 'Mükemmel! Profesyonel aday geri bildirimle gelişir. "Anlıyorum. Hangi noktayı geliştirmemi istersiniz?" diyerek hem sakinliğinizi hem gelişime açıklığınızı gösterirsiniz.',
        wrong: 'Bu tutum stres yönetimini zayıf gösterir. Havayolları eleştiriye yapıcı yaklaşan adayları tercih eder.'
      },
      explanation: 'Örnek cevap: "Teşekkür ederim geri bildiriminiz için. Daha detaylı açıklamamı ister misiniz? Şöyle ekleyebilirim..."'
    }
  },
  'CM-M6-U2-L1': {
    lesson_id: 'CM-M6-U2-L1',
    title: 'Nefes Teknikleri',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Stres Anında Nefes',
      paragraphs: [
        'Mülakat stresi normaldir. Bunu yönetmenin en basit yolu: NEFES.',
        'Teknik: 4-7-8 nefesi. 4 saniye nefes al, 7 saniye tut, 8 saniye ver.',
        'Bunu mülakat öncesi yapın. Mülakat sırasında da bir soru gelmeden önce derin nefes alabilirsiniz.',
        'Fiziksel etki: Kalp hızı düşer, kortizol azalır, odaklanma artar.'
      ],
      keyPoints: [
        '4-7-8 nefes tekniği',
        'Mülakat öncesi uygulayın',
        'Kalp hızını düşürür',
        'Odaklanmayı artırır'
      ]
    }
  },
  'CM-M6-U2-L2': {
    lesson_id: 'CM-M6-U2-L2',
    title: 'Pozitif Düşünce',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Zihinsel Hazırlık',
      paragraphs: [
        '"Ya başaramazsam?" düşüncesi performansı düşürür. Bunun yerine: "Elimden gelenin en iyisini yapacağım."',
        'Visualization: Mülakat öncesi gözünüzde canlandırın. Kapıdan giriyorsunuz, gülümsüyorsunuz, sorulara cevap veriyorsunuz.',
        'Power pose: Mülakat öncesi 2 dakika ayakta durun, elleriniz kalçada, göğüs açık. Bu güven hormonunu artırır.',
        'Mantra: Kendinize bir cümle söyleyin. "Ben hazırım", "Bu benim için doğru iş".'
      ],
      keyPoints: [
        'Negatif düşünceden kaçının',
        'Başarıyı görselleştirin',
        'Power pose yapın',
        'Pozitif mantra kullanın'
      ]
    }
  },
  'CM-M6-U2-L3': {
    lesson_id: 'CM-M6-U2-L3',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        {
          q: 'Eleştiriye doğru tepki nedir?',
          options: ['Savunma', 'Sessizlik', 'Geri bildirim istemek', 'Özür dilemek'],
          correct: 2
        },
        {
          q: 'Zayıf yön sorusuna ne denmeli?',
          options: ['"Yok"', 'Gerçekçi zayıflık + gelişim', 'Yalan söyle', 'Cevaplama'],
          correct: 1
        },
        {
          q: '4-7-8 nefes tekniği ne yapar?',
          options: ['Heyecanı artırır', 'Stresi azaltır', 'Uyutur', 'Hızlandırır'],
          correct: 1
        },
        {
          q: 'Power pose ne zaman yapılır?',
          options: ['Mülakat sırasında', 'Mülakat öncesi', 'Mülakat sonrası', 'Hiçbir zaman'],
          correct: 1
        }
      ]
    }
  },

  // ==================== MODÜL 7: DIŞ GÖRÜNÜM VE İMAJ ====================
  'CM-M7-U1-L1': {
    lesson_id: 'CM-M7-U1-L1',
    title: 'Profesyonel Görünüm',
    type: 'lesson',
    duration: 5,
    xp: 15,
    content: {
      title: 'Kıyafet ve Görünüm',
      paragraphs: [
        'Mülakatta "kabin memuru gibi" görünmelisiniz. Bu profesyonel ve bakımlı demektir.',
        'Kadınlar için: Koyu renk blazer/ceket, diz altı etek veya pantolon, kapalı burun topuklu ayakkabı (5-7 cm), doğal makyaj.',
        'Erkekler için: Koyu renk takım elbise, açık renk gömlek, kravat, cilalı ayakkabı, temiz tıraş.',
        'Her ikisi için: Ütülü kıyafet, temiz tırnaklar, az parfüm, saçlar düzenli.'
      ],
      keyPoints: [
        'Profesyonel ve bakımlı görünün',
        'Koyu renk kıyafet tercih edin',
        'Detaylara dikkat edin',
        'Abartıdan kaçının'
      ]
    }
  },
  'CM-M7-U1-L2': {
    lesson_id: 'CM-M7-U1-L2',
    title: 'Beden Dili',
    type: 'lesson',
    duration: 5,
    xp: 15,
    content: {
      title: 'Non-verbal İletişim',
      paragraphs: [
        'İletişimin %55\'i beden dilidir. Ne söylediğiniz kadar NASIL söylediğiniz önemli.',
        'Olumlu beden dili: Göz teması, gülümseme, dik duruş, açık eller, başla onaylama.',
        'Olumsuz beden dili: Kolları kavuşturma, ayakları kıpırdatma, göz kaçırma, çok hızlı konuşma.',
        'İpucu: Değerlendirmecinin beden dilini yansıtın (mirroring). Bu bilinçaltı bağ kurar.'
      ],
      keyPoints: [
        'Göz teması kurun',
        'Dik durun, gülümseyin',
        'Kolları kavuşturmayın',
        'Sakin ve kontrollü olun'
      ]
    }
  },
  'CM-M7-U1-L3': {
    lesson_id: 'CM-M7-U1-L3',
    title: 'Senaryo: İlk İzlenim',
    type: 'scenario',
    duration: 5,
    xp: 25,
    scenario: {
      question: 'Mülakatta ilk 30 saniye neden kritiktir?',
      context: 'Kapıdan girdiniz, değerlendirmecilerle göz göze geldiniz.',
      options: [
        { id: 'A', text: 'Heyecanı azaltır', isCorrect: false },
        { id: 'B', text: 'Profesyonellik algısı oluşturur', isCorrect: true },
        { id: 'C', text: 'Soruları kolaylaştırır', isCorrect: false },
        { id: 'D', text: 'Zaman kazandırır', isCorrect: false }
      ],
      feedback: {
        correct: 'Doğru! Havayolları ilk izlenimi ciddiye alır. İlk 30 saniyede: Giriş, selamlama, el sıkışma, oturma. Bunlar profesyonellik algınızı belirler.',
        wrong: 'Asıl etki algı yönetimidir. İlk izlenim, değerlendirmecinin sizin hakkınızda oluşturduğu ilk "resim"dir.'
      },
      explanation: 'İlk 30 saniye için: Gülümseyin, göz teması kurun, güvenli adımlarla yürüyün, el sıkışırken orta kuvvet uygulayın.'
    }
  },
  'CM-M7-U2-L1': {
    lesson_id: 'CM-M7-U2-L1',
    title: 'Saç ve Makyaj',
    type: 'lesson',
    duration: 5,
    xp: 15,
    content: {
      title: 'Grooming Standartları: Saç ve Makyaj',
      paragraphs: [
        'Kadınlar için saç: Uzunsa toplu (topuz, at kuyruğu değil profesyonel topuz), kısaysa düzenli. Doğal renkler.',
        'Kadınlar için makyaj: Doğal tonlar, net dudak rengi (kırmızı veya nude), düzgün kaş, ince eyeliner.',
        'Erkekler için: Temiz tıraş veya bakımlı sakal, düzenli saç kesimi, kirpik ve kaş bakımı.',
        'Her ikisi için: Ten bakımı önemli. Temiz, nemlı, düzgün cilt beklenir.'
      ],
      keyPoints: [
        'Saç düzenli ve profesyonel',
        'Makyaj doğal ama belirgin',
        'Cilt bakımı önemli',
        'Abartıdan kaçının'
      ]
    }
  },
  'CM-M7-U2-L2': {
    lesson_id: 'CM-M7-U2-L2',
    title: 'Kıyafet Seçimi',
    type: 'lesson',
    duration: 5,
    xp: 15,
    content: {
      title: 'Doğru Kıyafet Seçimi',
      paragraphs: [
        'Temel kural: "Zaten orada çalışıyormuş gibi" görünmek.',
        'Renkler: Koyu lacivert, siyah, koyu gri tercih edilir. İç giyimde beyaz veya pastel.',
        'Aksesuar: Minimal. Küçük küpe, ince saat, evlilik yüzüğü. Büyük kolyeler, bilezikler yasak.',
        'KONTROL LİSTESİ: Ütü, leke kontrolü, düğme kontrolü, koku kontrolü (parfüm az).'
      ],
      keyPoints: [
        'Koyu renkler tercih edin',
        'Aksesuar minimal olsun',
        'Ütü ve temizlik kontrolü',
        'Parfümü az sıkın'
      ]
    }
  },
  'CM-M7-U2-L3': {
    lesson_id: 'CM-M7-U2-L3',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 30,
    quiz: {
      questions: [
        {
          q: 'Mülakatta tercih edilen kıyafet rengi?',
          options: ['Kırmızı', 'Sarı', 'Koyu lacivert', 'Turuncu'],
          correct: 2
        },
        {
          q: 'Beden dilinin iletişimdeki payı?',
          options: ['%10', '%25', '%55', '%90'],
          correct: 2
        },
        {
          q: 'Kadınlar için ideal topuk yüksekliği?',
          options: ['2-3 cm', '5-7 cm', '10-12 cm', 'Düz taban'],
          correct: 1
        },
        {
          q: 'Aksesuar kuralı nedir?',
          options: ['Çok kullan', 'Minimal', 'Hiç kullanma', 'Sadece altın'],
          correct: 1
        }
      ]
    }
  },

  // ==================== MODÜL 8-9-10 içerikleri devam eder... ====================
  // Burada kısaltıyorum, devam etmemi isterseniz ekleyebilirim

  // MODÜL 8: GRUP MÜLAKATI SİMÜLASYONU
  'CM-M8-U1-L1': {
    lesson_id: 'CM-M8-U1-L1',
    title: 'Tarafsız Kalma',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Anlaşmazlıkta Tarafsızlık',
      paragraphs: [
        'Grup çalışmasında bazen anlaşmazlık çıkar. TARAF TUTMAYIN.',
        'Doğru yaklaşım: Her iki fikri dinle, ortak nokta bul, uzlaştır.',
        '"Ali\'nin dediği de mantıklı, Ayşe\'nin fikri de. İkisini birleştirsek..." gibi.',
        'Taraf tutmak = Eleme riski. Uzlaştırıcı olmak = Ekip uyumu göstergesi.'
      ],
      keyPoints: [
        'Taraf tutmayın',
        'Her iki tarafı dinleyin',
        'Ortak nokta bulun',
        'Uzlaştırıcı olun'
      ]
    }
  },
  'CM-M8-U1-L2': {
    lesson_id: 'CM-M8-U1-L2',
    title: 'Ortak Çözüm',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Çözüm Odaklı Yaklaşım',
      paragraphs: [
        'Problem odaklı değil, ÇÖZÜM odaklı olun.',
        '"Bu işe yaramaz" yerine "Şöyle yaparsak işe yarayabilir" deyin.',
        'Grubun hedefini hatırlatın: "Amacımız X. Bunu başarmak için Y yapabiliriz."',
        'Her fikre "evet, ve..." ile ekleyin. "Evet, bu iyi fikir, ve buna Z\'yi ekleyebiliriz."'
      ],
      keyPoints: [
        'Çözüm odaklı olun',
        '"Evet, ve..." dili kullanın',
        'Hedefi hatırlatın',
        'Yapıcı katkı sağlayın'
      ]
    }
  },
  'CM-M8-U1-L3': {
    lesson_id: 'CM-M8-U1-L3',
    title: 'Simülasyon: Anlaşmazlık',
    type: 'scenario',
    duration: 10,
    xp: 40,
    scenario: {
      question: 'Ekip içinde anlaşmazlık çıktı. Ne yaparsınız?',
      context: 'İki aday farklı fikirler savunuyor ve gerginlik artıyor.',
      options: [
        { id: 'A', text: 'Bir tarafa destek veririm', isCorrect: false },
        { id: 'B', text: 'Sessiz kalır izlerim', isCorrect: false },
        { id: 'C', text: 'İki fikri birleştiren ortak çözüm öneririm', isCorrect: true }
      ],
      feedback: {
        correct: 'Mükemmel! Kabin memuru denge kurar ve uzlaştırır. "İkinizin de fikirleri değerli. Belki şöyle birleştirebiliriz..." yaklaşımı idealdir.',
        wrong: 'Bu davranış ekip uyumunu zedeler. Havayolları uzlaştırıcı adayları tercih eder.'
      },
      explanation: 'Uzlaştırma formülü: 1) Her iki fikri özetle, 2) Ortak noktayı vurgula, 3) Birleşik çözüm öner.'
    }
  },

  // MODÜL 9: BİREBİR MÜLAKAT
  'CM-M9-U1-L1': {
    lesson_id: 'CM-M9-U1-L1',
    title: 'Profesyonel Motivasyon',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: '"Neden Kabin Memuru?" Sorusu',
      paragraphs: [
        'Bu soru HER mülakatta sorulur. Hazırlıklı olmalısınız.',
        'YANLIŞ cevaplar: "Gezmek istiyorum", "Çocukluk hayalim", "İyi maaş".',
        'DOĞRU cevap yapısı: Profesyonel motivasyon + kişisel değerler + şirket eşleşmesi.',
        'Örnek: "İnsan güvenliğini sağlama sorumluluğu ve farklı kültürlerle çalışma fırsatı beni çekiyor. THY\'nin misafirperverlik değerleri kendi değerlerimle örtüşüyor."'
      ],
      keyPoints: [
        'Profesyonel motivasyon gösterin',
        '"Gezmek" demeyin',
        'Şirket değerlerine bağlayın',
        'Samimi ama profesyonel olun'
      ]
    }
  },
  'CM-M9-U1-L3': {
    lesson_id: 'CM-M9-U1-L3',
    title: 'Simülasyon: Motivasyon',
    type: 'scenario',
    duration: 10,
    xp: 40,
    scenario: {
      question: 'Neden kabin memuru olmak istiyorsunuz?',
      context: 'Bu klasik soru. Cevabınız motivasyonunuzu gösterir.',
      options: [
        { id: 'A', text: 'Çocukluk hayalim', isCorrect: false },
        { id: 'B', text: 'Maaş ve kariyer fırsatları', isCorrect: false },
        { id: 'C', text: 'İnsan güvenliği sorumluluğu ve ekip çalışması', isCorrect: true }
      ],
      feedback: {
        correct: 'Mükemmel! Motivasyon profesyonel temele dayanmalı. Güvenlik sorumluluğu, ekip çalışması, müşteri hizmeti gibi profesyonel nedenler güçlü cevaptır.',
        wrong: 'Bu cevaplar yüzeysel kabul edilir. Havayolları profesyonel motivasyon arar.'
      },
      explanation: 'İdeal cevap: Güvenlik + Hizmet + Ekip çalışması + Şirket değerleri.'
    }
  },

  // MODÜL 10: FİNAL DEĞERLENDİRME
  'CM-M10-U1-L1': {
    lesson_id: 'CM-M10-U1-L1',
    title: 'Modül 1-5 Tekrar',
    type: 'review',
    duration: 10,
    xp: 30,
    content: {
      title: 'Kapsamlı Tekrar: Bölüm 1',
      paragraphs: [
        'MODÜL 1: Kabin memurluğu = Güvenlik personeli. Servis ikincil.',
        'MODÜL 2: Takım uyumu en önemli kriter. Boy ve sağlık fiziksel gereklilikler.',
        'MODÜL 3: Ne baskın ne pasif ol. Aktif dinle, yapıcı katkı sağla.',
        'MODÜL 4: Ezberden kaçın, gerçek refleksini göster. Az ve öz konuş.',
        'MODÜL 5: Empati + Prosedür = Zor yolcu çözümü. Güvenlik her zaman #1.'
      ],
      keyPoints: [
        'Güvenlik öncelikli',
        'Takım uyumu kritik',
        'Denge kur',
        'Ezberden kaçın'
      ]
    }
  },
  'CM-M10-U1-L2': {
    lesson_id: 'CM-M10-U1-L2',
    title: 'Modül 6-9 Tekrar',
    type: 'review',
    duration: 10,
    xp: 30,
    content: {
      title: 'Kapsamlı Tekrar: Bölüm 2',
      paragraphs: [
        'MODÜL 6: Eleştiriye açık ol, stres yönetimini göster.',
        'MODÜL 7: Profesyonel görünüm, beden dili, ilk izlenim.',
        'MODÜL 8: Grup mülakatında uzlaştırıcı ol, taraf tutma.',
        'MODÜL 9: Motivasyon sorusuna profesyonel cevap ver.'
      ],
      keyPoints: [
        'Eleştiriye açık ol',
        'Profesyonel görün',
        'Uzlaştırıcı ol',
        'Profesyonel motivasyon göster'
      ]
    }
  },
  'CM-FINAL-EXAM': {
    lesson_id: 'CM-FINAL-EXAM',
    title: 'Final Sınavı',
    type: 'exam',
    duration: 30,
    xp: 200,
    exam: {
      passing_score: 70,
      questions: [
        { q: 'Kabin memurunun birincil görevi?', options: ['Servis', 'Güvenlik', 'Satış', 'Eğlence'], correct: 1 },
        { q: 'Grup mülakatında en önemli kriter?', options: ['Liderlik', 'İngilizce', 'Takım uyumu', 'Deneyim'], correct: 2 },
        { q: 'Çok baskın aday ne yapar?', options: ['Dinler', 'Sözü keser', 'Uzlaştırır', 'Bekler'], correct: 1 },
        { q: 'Ezber cevabın riski?', options: ['Unutmak', 'Gerçek refleksi gizler', 'Uzunluk', 'Yanlışlık'], correct: 1 },
        { q: 'Zor yolcuya doğru yaklaşım?', options: ['Uyar', 'Empati + Prosedür', 'Görmezden gel', 'Amire yolla'], correct: 1 },
        { q: 'Türbülansta öncelik?', options: ['Servis', 'Güvenlik pozisyonu', 'Yolcu', 'Kokpit'], correct: 1 },
        { q: 'Eleştiriye doğru tepki?', options: ['Savunma', 'Sessizlik', 'Geri bildirim iste', 'Özür'], correct: 2 },
        { q: 'İlk 30 saniye neden önemli?', options: ['Heyecan', 'Profesyonellik algısı', 'Zaman', 'Soru'], correct: 1 },
        { q: 'Anlaşmazlıkta ne yapmalı?', options: ['Taraf tut', 'Sus', 'Uzlaştır', 'Çık'], correct: 2 },
        { q: 'Motivasyon sorusuna ne denmeli?', options: ['Gezmek', 'Maaş', 'Güvenlik sorumluluğu', 'Hayal'], correct: 2 }
      ],
      result_thresholds: {
        ready: { min: 85, label: '✅ Mülakata Hazır' },
        conditional: { min: 70, label: '⚠️ Geliştirilmeli' },
        not_ready: { min: 0, label: '❌ Şu An Uygun Değil' }
      }
    }
  },

  // ==================== MODÜL 8: GRUP MÜLAKATI - EK OYUNLAR ====================
  'CM-M8-U2-L1': {
    lesson_id: 'CM-M8-U2-L1',
    title: 'Özgüvenli Duruş',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Sunum Yaparken Özgüven',
      paragraphs: [
        'Grup mülakatında sunum yapmak isteyebilirsiniz. Bu, kendinizi gösterme fırsatıdır.',
        'Özgüvenli duruş = Dik durun, omuzlar geri, göğüs açık. Ellerinizi cebinize sokmayın.',
        'Ses tonu = Monotondan kaçının. Önemli noktalarda vurgulayın. Çok hızlı konuşmayın.',
        'Göz teması = Sadece bir kişiye değil, tüm gruba bakın. Her kişiyle kısa göz teması kurun.'
      ],
      keyPoints: [
        'Dik durun, omuzlar geri',
        'Ses tonunuzu kullanın',
        'Tüm gruba bakın',
        'Sakin ve kontrollü olun'
      ]
    }
  },
  'CM-M8-U2-L2': {
    lesson_id: 'CM-M8-U2-L2',
    title: 'Etkili Anlatım',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Sunum Teknikleri',
      paragraphs: [
        'İyi bir sunum: Giriş + Ana Bölüm + Sonuç yapısında olmalı.',
        'Giriş: Ne anlatacağınızı kısaca özetleyin. "Şunu anlatacağım..." ile başlayın.',
        'Ana bölüm: 2-3 nokta yapın. Her nokta için örnek verin.',
        'Sonuç: Söylediklerinizi özetleyin. "Sonuç olarak..." ile bitirin.'
      ],
      keyPoints: [
        'Giriş-Gelişme-Sonuç yapısı',
        'Somut örnekler verin',
        '2-3 ana nokta yeterli',
        'Özet ile bitirin'
      ]
    }
  },
  'CM-M8-U2-L3': {
    lesson_id: 'CM-M8-U2-L3',
    title: 'Simülasyon: Sunum',
    type: 'scenario',
    duration: 10,
    xp: 40,
    scenario: {
      question: 'Grup önünde sunum yapmanız istendi. En iyi yaklaşım hangisi?',
      context: 'Değerlendirmeciler gruba "Her biriniz kendi şehrinizi tanıtın" dedi.',
      options: [
        { id: 'A', text: 'Çok detaylı ve uzun anlatırım', isCorrect: false },
        { id: 'B', text: 'Kısa, yapılandırılmış, örnekli anlatırım', isCorrect: true },
        { id: 'C', text: 'Sadece temel bilgileri söylerim', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Kısa, yapılandırılmış ve örnekli sunum en etkili olandır. "İstanbul\'u tanıtacağım: tarihi, yemekleri ve ulaşımı." gibi yapı kurun.',
        wrong: 'Sunum dengesini kaçırmak risk oluşturur. Ne çok uzun ne çok kısa olmalı.'
      },
      explanation: 'İdeal sunum: 1-2 dakika, 2-3 ana nokta, her noktaya örnek, gülümseyerek bitirin.'
    }
  },

  // 🎮 MODÜL 8 - Zaman Yarışı
  'CM-M8-U2-L4': {
    lesson_id: 'CM-M8-U2-L4',
    title: '⚡ Zaman Yarışı: Grup Mülakatı',
    type: 'timerace',
    duration: 3,
    xp: 50,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Grup çalışmasında taraf tutmak?', options: ['İyi', 'Kötü', 'Önemsiz', 'Normal'], correct: 1 },
        { q: 'Sunum yapısı nasıl olmalı?', options: ['Sadece giriş', 'Giriş-Gelişme-Sonuç', 'Sadece sonuç', 'Rastgele'], correct: 1 },
        { q: 'Anlaşmazlıkta ne yapmalı?', options: ['Taraf tut', 'Sessiz kal', 'Uzlaştır', 'Çık'], correct: 2 },
        { q: 'Sunum süresi ne kadar?', options: ['5 dakika', '10 dakika', '1-2 dakika', '30 saniye'], correct: 2 },
        { q: 'Göz teması kiminle?', options: ['Sadece lider', 'Tüm grup', 'Hiç kimse', 'Masa'], correct: 1 },
      ]
    }
  },

  // 🎮 MODÜL 8 - Eşleştirme Oyunu
  'CM-M8-U2-L5': {
    lesson_id: 'CM-M8-U2-L5',
    title: '🎮 Eşleştir: Sunum İpuçları',
    type: 'matching',
    duration: 3,
    xp: 30,
    matching: {
      pairs: [
        { id: 1, left: 'Dik duruş', right: 'Özgüven gösterir' },
        { id: 2, left: 'Göz teması', right: 'Tüm grupla kurun' },
        { id: 3, left: 'Ses tonu', right: 'Monotondan kaçının' },
        { id: 4, left: 'Sunum yapısı', right: 'Giriş-Gelişme-Sonuç' },
        { id: 5, left: 'Sunum süresi', right: '1-2 dakika ideal' },
      ]
    }
  },

  // ==================== MODÜL 9: BİREBİR MÜLAKAT - EK İÇERİKLER ====================
  'CM-M9-U1-L2': {
    lesson_id: 'CM-M9-U1-L2',
    title: 'Yüzeysel Cevaplardan Kaçınma',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Derinlikli Cevaplar',
      paragraphs: [
        'Yüzeysel cevaplar adayı zayıf gösterir. "Gezmek istiyorum" veya "İnsanları seviyorum" yeterli değil.',
        'Derinlik nasıl eklenir? NEDEN sorusunu kendinize sorun. "Neden insanları seviyorum?" → "Çünkü farklı kültürlerden öğrenmek beni geliştiriyor."',
        'Somut örnek verin. "İnsanları seviyorum" → "Starbucks\'ta çalışırken her gün onlarca müşteriyle muhatap oldum ve bu deneyim bana..."',
        'Profesyonel bağlam kurun. Cevabınızı havacılık veya hizmet sektörüne bağlayın.'
      ],
      keyPoints: [
        'NEDEN sorusunu sorun',
        'Somut örnek verin',
        'Profesyonel bağlam kurun',
        '"Çünkü" ile açıklayın'
      ]
    }
  },

  // 🎮 MODÜL 9 - Sürükle Bırak: İdeal Cevap Yapısı
  'CM-M9-U1-L4': {
    lesson_id: 'CM-M9-U1-L4',
    title: '🎮 Sırala: Motivasyon Cevabı',
    type: 'dragdrop',
    duration: 3,
    xp: 30,
    dragdrop: {
      instruction: '"Neden kabin memuru?" cevabının doğru sırasını belirleyin',
      items: [
        { text: '1️⃣ Profesyonel motivasyon belirt', order: 1 },
        { text: '2️⃣ Kişisel deneyimden örnek ver', order: 2 },
        { text: '3️⃣ Şirket değerlerine bağla', order: 3 },
        { text: '4️⃣ Gelecek hedefini söyle', order: 4 },
      ]
    }
  },

  // MODÜL 9 - Ünite 2: Kendini Tanıtma
  'CM-M9-U2-L1': {
    lesson_id: 'CM-M9-U2-L1',
    title: 'Yapılandırılmış Cevap',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Tell Me About Yourself',
      paragraphs: [
        '"Kendinizi tanıtın" sorusu her mülakatta sorulur. Hazırlıksız yakalanmayın.',
        'YANLIŞ: Biyografik bilgi ("1998\'de doğdum, üniversite okudum..."). Değerlendirmeci CV\'nizi okudu zaten.',
        'DOĞRU: Profesyonel özet + Güçlü yönler + Neden buradayım.',
        'Örnek: "Hizmet sektöründe 3 yıllık deneyimim var. İnsan ilişkilerinde güçlüyüm. Kabin memurluğu bu güçlerimi kullanabileceğim ideal pozisyon."'
      ],
      keyPoints: [
        'Biyografik bilgi değil',
        'Profesyonel özet + Güçlü yönler',
        'Neden bu pozisyon',
        '30-60 saniye'
      ]
    }
  },
  'CM-M9-U2-L2': {
    lesson_id: 'CM-M9-U2-L2',
    title: 'Güçlü Yönler',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'Güçlü Yönlerinizi Sunma',
      paragraphs: [
        'Güçlü yönlerinizi söylerken SOMUT olun. "İyi iletişimim var" yetmez.',
        'STAR metodu kullanın: Situation (Durum), Task (Görev), Action (Eylem), Result (Sonuç).',
        'Örnek: "Bir müşteri kızgınlıkla geldi (S). Sorununu çözmem gerekiyordu (T). Onu dinledim ve alternatif sundum (A). Memnun ayrıldı ve teşekkür etti (R)."',
        'Havacılık bağlantısı kurun: "Bu deneyim beni kabin ekibi için hazırladı."'
      ],
      keyPoints: [
        'Somut örnekler verin',
        'STAR metodu kullanın',
        'Havacılık bağlantısı kurun',
        'Her örnek 30 saniye'
      ]
    }
  },
  'CM-M9-U2-L3': {
    lesson_id: 'CM-M9-U2-L3',
    title: 'Simülasyon: Tanıtım',
    type: 'scenario',
    duration: 10,
    xp: 40,
    scenario: {
      question: '"Kendinizi tanıtın" sorusuna en iyi yanıt hangisi?',
      context: 'Birebir mülakatta değerlendirmeci bu soruyu sordu.',
      options: [
        { id: 'A', text: '1998\'de İstanbul\'da doğdum, lise sonra üniversite...', isCorrect: false },
        { id: 'B', text: 'Hizmet sektöründe deneyimim var, iletişimde güçlüyüm, THY\'de bu yetenekleri kullanmak istiyorum', isCorrect: true },
        { id: 'C', text: 'Çalışkanım, dürüstüm, insanları severim', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Profesyonel özet + güçlü yön + şirket bağlantısı = ideal cevap. Kısa, öz ve hedef odaklı.',
        wrong: 'Bu cevap yapısı zayıf. Değerlendirmeci CV\'deki biyografik bilgileri değil, profesyonel değerinizi görmek ister.'
      },
      explanation: 'İdeal yapı: 1) Profesyonel özet (10 san), 2) Güçlü yön + örnek (30 san), 3) Şirket bağlantısı (10 san).'
    }
  },

  // 🎮 MODÜL 9 - Doğru/Yanlış: Birebir Mülakat
  'CM-M9-U2-L4': {
    lesson_id: 'CM-M9-U2-L4',
    title: '🎮 Doğru mu Yanlış mı?',
    type: 'truefalse',
    duration: 3,
    xp: 25,
    truefalse: {
      statements: [
        { statement: 'Kendinizi tanıtırken doğum tarihinizi söyleyin.', isTrue: false, explanation: 'Hayır! Biyografik bilgi değil, profesyonel özet verin.' },
        { statement: 'STAR metodu cevap yapılandırmak için kullanılır.', isTrue: true, explanation: 'Doğru! Situation-Task-Action-Result.' },
        { statement: '"Gezmek istiyorum" iyi bir motivasyon cevabıdır.', isTrue: false, explanation: 'Yanlış! Bu yüzeysel ve profesyonel değil.' },
        { statement: 'Kendinizi tanıtırken 30-60 saniye yeterlidir.', isTrue: true, explanation: 'Doğru! Kısa ve öz olun.' },
        { statement: 'Güçlü yönler için somut örnek şart değildir.', isTrue: false, explanation: 'Yanlış! Somut örnek olmadan inandırıcı olmaz.' },
      ]
    }
  },

  // MODÜL 9 - Ünite 3: STAR Metodu
  'CM-M9-U3-L1': {
    lesson_id: 'CM-M9-U3-L1',
    title: 'Situation-Task',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'STAR: Durum ve Görev',
      paragraphs: [
        'STAR metodu davranışsal sorularda kullanılır. "Bir zor müşteriyle nasıl başa çıktınız?" gibi.',
        'S - Situation (Durum): Kısa ve net olarak durumu tanımlayın. "Geçen yıl kafede çalışırken..."',
        'T - Task (Görev): Ne yapmanız gerekiyordu? "Kızgın bir müşteriyi sakinleştirmem gerekiyordu."',
        'Bu iki bölüm toplam 10-15 saniye sürmeli. Çok detaya girmeyin.'
      ],
      keyPoints: [
        'Situation = Durum (5-7 saniye)',
        'Task = Görev (5-7 saniye)',
        'Kısa ve net olun',
        'Gereksiz detay vermeyin'
      ]
    }
  },
  'CM-M9-U3-L2': {
    lesson_id: 'CM-M9-U3-L2',
    title: 'Action-Result',
    type: 'lesson',
    duration: 5,
    xp: 20,
    content: {
      title: 'STAR: Eylem ve Sonuç',
      paragraphs: [
        'A - Action (Eylem): NE yaptınız? Detaylı anlatın. "Önce onu dinledim, sonra özür diledim, alternatif sundum."',
        'R - Result (Sonuç): Ne oldu? Olumlu sonuç verin. "Müşteri memnun ayrıldı ve bize teşekkür etti."',
        'Eylem bölümü en önemli kısım. Burada NASIL düşündüğünüzü ve hareket ettiğinizi gösterin.',
        'Sonuç her zaman olumlu olmalı. Başarısız bir hikaye anlatmayın.'
      ],
      keyPoints: [
        'Action = Eylem (20-25 saniye)',
        'Result = Sonuç (5-10 saniye)',
        'Eylem detaylı olsun',
        'Sonuç olumlu olsun'
      ]
    }
  },
  'CM-M9-U3-L3': {
    lesson_id: 'CM-M9-U3-L3',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        {
          q: 'STAR metodunda S ne anlama gelir?',
          options: ['Success', 'Situation', 'Solution', 'Strategy'],
          correct: 1
        },
        {
          q: 'STAR cevabında en uzun bölüm hangisi?',
          options: ['Situation', 'Task', 'Action', 'Result'],
          correct: 2
        },
        {
          q: 'STAR metodunda olumsuz sonuç anlatılır mı?',
          options: ['Evet', 'Hayır', 'Bazen', 'Fark etmez'],
          correct: 1
        },
        {
          q: 'Tell me about yourself sorusuna ne kadar süre ayrılır?',
          options: ['10 saniye', '30-60 saniye', '3 dakika', '5 dakika'],
          correct: 1
        }
      ]
    }
  },

  // 🎮 MODÜL 9 - Zaman Yarışı: Birebir Mülakat
  'CM-M9-U3-L4': {
    lesson_id: 'CM-M9-U3-L4',
    title: '⚡ Zaman Yarışı: Birebir Mülakat',
    type: 'timerace',
    duration: 3,
    xp: 50,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'STAR\'da T ne demek?', options: ['Time', 'Task', 'Team', 'Target'], correct: 1 },
        { q: '"Gezmek istiyorum" iyi mi?', options: ['Evet', 'Hayır', 'Belki', 'Fark etmez'], correct: 1 },
        { q: 'Kendinizi tanıtma süresi?', options: ['5 saniye', '30-60 saniye', '5 dakika', '10 dakika'], correct: 1 },
        { q: 'STAR\'da en uzun bölüm?', options: ['Situation', 'Task', 'Action', 'Result'], correct: 2 },
        { q: 'Motivasyon sorusunda ne vurgulayın?', options: ['Maaş', 'Gezme', 'Profesyonel değer', 'Üniforma'], correct: 2 },
        { q: 'Zayıf yön sorusuna ne denmeli?', options: ['"Yok"', 'Gerçekçi + gelişim', 'Yalan', 'Susmak'], correct: 1 },
      ]
    }
  },

  // 🎮 MODÜL 9 - Boşluk Doldurma
  'CM-M9-U3-L5': {
    lesson_id: 'CM-M9-U3-L5',
    title: '🎮 Boşluk Doldur: Mülakat Cümleleri',
    type: 'fillin',
    duration: 4,
    xp: 35,
    fillin: {
      sentences: [
        { text: '"Kendinizi tanıtın" sorusuna ___ özet verin.', answer: 'profesyonel' },
        { text: 'STAR metodunun S\'si ___ anlamına gelir.', answer: 'Situation' },
        { text: 'Güçlü yönler için ___ örnek vermek şarttır.', answer: 'somut' },
        { text: 'Kabin memuru motivasyonunda ___ vurgulayın.', answer: 'sorumluluk' },
        { text: '"Gezmek istiyorum" cevabı ___ kabul edilir.', answer: 'yüzeysel' },
      ]
    }
  },

  // MODÜL 10 - Final Simülasyonları ek içerik
  'CM-M10-U2-L1': {
    lesson_id: 'CM-M10-U2-L1',
    title: 'Grup Mülakatı Final',
    type: 'scenario',
    duration: 15,
    xp: 50,
    scenario: {
      question: 'Grup aktivitesinde kimse fikrini söylemiyor. 2 dakika geçti. Ne yaparsınız?',
      context: 'Final simülasyonu: Havayolu logosu tasarlama görevi verildi. Grup sessiz.',
      options: [
        { id: 'A', text: 'Kontrolü alıp liderlik yaparım', isCorrect: false },
        { id: 'B', text: 'Nazikçe başlatıcı bir soru sorarım', isCorrect: true },
        { id: 'C', text: 'Sessiz kalıp beklerim', isCorrect: false },
        { id: 'D', text: 'Değerlendirmeciye sorun yaşadığımızı söylerim', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! "Belki herkes kendi fikrini söyleyebilir? Ben başlayayım..." gibi nazik bir başlatıcı ideal. Liderlik dayatması değil, kolaylaştırıcılık.',
        wrong: 'Bu yaklaşım ekip uyumunu zedeler. Ne baskın ol ne pasif - denge kur.'
      },
      explanation: 'Final ipucu: Grup aktivitelerinde ARAYI DOLDUR. Sessizlikte başlat, tartışmada uzlaştır, sunumda destek ol.'
    }
  },
  'CM-M10-U2-L2': {
    lesson_id: 'CM-M10-U2-L2',
    title: 'Birebir Mülakat Final',
    type: 'scenario',
    duration: 15,
    xp: 50,
    scenario: {
      question: 'Değerlendirmeci: "Bir zayıf yönünüzü söyleyin." En iyi cevap?',
      context: 'Final simülasyonu: Birebir mülakatta bu kritik soru soruldu.',
      options: [
        { id: 'A', text: 'Zayıf yönüm yok', isCorrect: false },
        { id: 'B', text: 'Bazen detaylara takılıyorum ama öncelik belirlemeyi öğrendim', isCorrect: true },
        { id: 'C', text: 'Sabırsızım', isCorrect: false },
        { id: 'D', text: 'İngilizcem zayıf', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Gerçekçi zayıflık + gelişim = ideal cevap. "Farkındayım ve üzerinde çalışıyorum" mesajı verir.',
        wrong: '"Yok" demek kibirli, kritik zayıflık söylemek riskli. Denge gerekli.'
      },
      explanation: 'Zayıf yön formülü: 1) Gerçek ama kritik olmayan zayıflık, 2) Farkındalık gösterin, 3) Nasıl geliştirdiğinizi söyleyin.'
    }
  }
};

// Tüm modülleri birleştir - ESKİ İÇERİKLER ÖNCE, İNTERAKTİF İÇERİKLER SON (üzerine yazar)
const cabinCrewContents = {
  ...cabinCrewContentsBase,
  // Eski içerikler (statik)
  ...cabinCrewContentsM11,
  ...cabinCrewContentsM12,
  ...cabinCrewContentsM13,
  ...cabinCrewContentsM14,
  ...cabinCrewContentsM15,
  ...cabinCrewContentsM16,
  ...cabinCrewContentsM1Extra,
  ...cabinCrewContentsM2Extra,
  ...cabinCrewContentsM3Extra,
  ...cabinCrewContentsM4Extra,
  ...cabinCrewContentsM5Extra,
  ...cabinCrewContentsM6Extra,
  ...cabinCrewContentsM8Extra,
  ...cabinCrewContentsM9Extra,
  ...cabinCrewContentsM1U3to6,
  ...cabinCrewContentsM2U3to6,
  ...cabinCrewContentsM3U3to6,
  ...cabinCrewContentsM4U3to6,
  ...cabinCrewContentsM5U3to7,
  // İNTERAKTİF İÇERİKLER EN SON - varsa eski içeriklerin üzerine yazar
  ...cabinCrewContentsM2Interactive,
  ...cabinCrewContentsM3Interactive,
  ...cabinCrewContentsM4Interactive,
  ...cabinCrewContentsM5Interactive,
  ...cabinCrewContentsM6Interactive,
  ...cabinCrewContentsM7Interactive,
  ...cabinCrewContentsM8Interactive,
  ...cabinCrewContentsM9Interactive,
  ...cabinCrewContentsM10Interactive,
  ...cabinCrewContentsM11M12Interactive,
  ...cabinCrewContentsM13M14Interactive,
  ...cabinCrewContentsM15M16Interactive
};

// Helper fonksiyonlar
export const getCabinLessonContent = (lessonId) => {
  // Önce mülakat içeriklerinde ara (INT- ile başlayanlar)
  if (lessonId && lessonId.startsWith("INT-")) {
    return interviewContents[lessonId] || null;
  }
  // Sonra kabin içeriklerinde ara
  return cabinCrewContents[lessonId] || null;
};

export const getCabinModuleLessons = (moduleId) => {
  const prefix = `CM-M${moduleId}`;
  return Object.values(cabinCrewContents).filter(c => c.lesson_id.startsWith(prefix));
};

// Get all cabin lesson contents for bulk import
export const getAllCabinLessonContents = () => {
  return cabinCrewContents;
};

export default cabinCrewContents;
